/**
 * @file Generated by generate-resources.ts
 */

export const i18nResources = {
  "it": {
    "translation": {
      "actor-permission-icon.permesso-firmare-modulo": "{{canSign}} firmare il modulo.",
      "actor-permission-icons.can": "Puoi",
      "actor-permission-icons.cannot": "Non puoi",
      "actor-permission-icons.permesso-compilare-modulo": "{{canCompile}} compilare il modulo.",
      "actor-permission-icons.permesso-visualizzazione-modulo": "{{canView}} visualizzare il modulo.",
      "actor-role-tag.tipo-utente-delegato": "Sei {{tagOption}} della Richiesta.",
      "addess-book.delete-row.confirm-title": "Rimuovere la voce dalla rubrica?",
      "addess-book.form.apply": "Applica",
      "addess-book.form.cancel": "Annulla",
      "addess-book.search": "Ricerca",
      "addres-book.create.success": "Anagrafica delegato creata con successo",
      "address-book.already-selected": "Selezionato",
      "address-book.azioni": "Azioni",
      "address-book.button.apri-rubrica": "Apri rubrica",
      "address-book.columns.codice-fiscale": "Codice Fiscale",
      "address-book.columns.cognome": "Cognome",
      "address-book.columns.email": "Email",
      "address-book.columns.identificativo": "Identificativo",
      "address-book.columns.indirizzo": "Indirizzo",
      "address-book.columns.nome": "Nome",
      "address-book.columns.nome-completo": "Nome",
      "address-book.columns.note": "Note",
      "address-book.create.button-label": "Nuovo delegato",
      "address-book.drawer.title": "Configurazione delegato",
      "address-book.edit-button.aria-label": "Vai alla Modifica",
      "address-book.edit-button.tooltip": "Modifica",
      "address-book.edit-create.error": "Errore durante il salvataggio",
      "address-book.edit.success": "Anagrafica delegato modificata con successo",
      "address-book.edit.user-origin": "Provenienza Utente",
      "address-book.filter-schema.label.ricerca-per-altri-campi": "Ricerca per altri campi",
      "address-book.filter-schema.label.ricerca-per-cf": "Ricerca per CF/E-Mail",
      "address-book.filtered.message": "Anagrafiche trovate con i filtri selezionati",
      "address-book.input.fiscal-code.aria-label": "Ricerca Codice Fiscale/Email",
      "address-book.input.fiscal-code.placeholder": "Codice Fiscale/Email",
      "address-book.input.name.aria-label": "Ricerca per altri campi",
      "address-book.input.name.placeholder": "Nome/cognome...",
      "address-book.modal.empty-list.description1.nessun-delegato-vai-alla": "Nessun delegato presente nella rubrica. Vai alla",
      "address-book.modal.empty-list.description2.link.rubrica": "Rubrica",
      "address-book.modal.empty-list.description3.per-aggiungerne-di-nuovi": "per aggiungerne di nuovi.",
      "address-book.modal.empty-list.message.rubrica-vuota": "Rubrica vuota",
      "address-book.modal.error.errore-caricamento-rubrica": "Errore durante il carimaneto della rubrica",
      "address-book.modal.title.seleziona-delegato": "Seleziona delegato",
      "address-book.page.breadcrumb.gestione-deleghe": "Gestione Deleghe",
      "address-book.page.breadcrumb.richieste": "Richieste",
      "address-book.page.breadcrumb.rubrica": "Rubrica",
      "address-book.page.error.impossibile-caricare-la-rubrica": "Impossibile caricare la rubrica",
      "address-book.remove-filter-button.label": "Rimuovi filtri",
      "address-book.remove.error": "Errore durante l'eliminazione",
      "address-book.remove.success": "Voce rimossa con successo",
      "address-book.searchable-fields.identificativo-label": "Identificativo",
      "address-book.searchable-fields.identificativo-placeholder": "CF/E-Mail...",
      "address-book.searchable-fields.ricerca-altri-campi-label": "Ricerca per altri campi",
      "address-book.searchable-fields.ricerca-altri-campi-placeholder": "Nome, cognome, indirizzo...",
      "address-book.select": "Seleziona",
      "address-book.title": "Rubrica delegati",
      "address-book.torna-alle-deleghe": "Torna alle deleghe",
      "annulla-modifiche": "Annulla modifiche",
      "archive-data.autore": "Autore:",
      "archive-data.codice-invio": "Codice invio:",
      "archive-data.data-invio": "Data invio:",
      "archive-data.numero-fascicolo": "Numero Fascicolo:",
      "archive-data.numero-protocollo": "Numero Protocollo:",
      "archive-data.oggetto": "Oggetto:",
      "archive-data.stato": "Stato:",
      "archive-details.fascicolo": "Fascicolo",
      "archive-details.ricevuta-invio": "Ricevuta invio",
      "archived-submission.impossibile-caricare-dettaglio-richiesta": "Impossibile caricare il dettaglio dell'Istanza archiviata.",
      "archived-submission.lists-istanze-trovate-in-base-ai-filtri": "istanze archiviate trovate in base ai filtri di ricerca.",
      "archived-submissions.back-to-requests": "Le mie istanze",
      "archived-submissions.columns.see-details-text": "Apri la pagina di dettaglio della richiesta",
      "archived-submissions.columns.see-details-tooltip": "Visualizza richiesta",
      "archived-submissions.columns.subject": "Oggetto",
      "archived-submissions.impossibile-caricare-elenco-richieste": "Impossibile caricare l'elenco delle Istanze archiviate",
      "archived-submissions.list-archived-title": "Elenco Richieste Archiviate",
      "archived-submissions.protocol-signature": "Numero Protocollo",
      "archived-submissions.search.data-invio-al": "Al",
      "archived-submissions.search.data-invio-dal": "Dal",
      "archived-submissions.search.protocol": "Numero Protocollo",
      "archived-submissions.search.sentDate": "Data Invio",
      "archived-submissions.search.subject": "Oggetto",
      "archived-submissions.sent-at": "Data Invio",
      "archived-submissions.state": "Stato",
      "archived-submissions.status": "ARCHIVIATA",
      "burden-selection-table.errore-in-creazione-pagamento": "Si è verificato un errore durante la creazione del pagamento. Riprovare.",
      "change-submission-manager-button.input.can-submit.checkbox-text.permesso-di-invio": "Permesso di invio",
      "change-submission-manager-button.input.can-submit.help.permetti-al-procuratore-indicato-di-inviare-la-richiesta": "Permetti al procuratore indicato di inviare la richiesta",
      "change-submission-manager-button.input.can-submit.label.invio-richiesta": "Invio richiesta",
      "change-submission-manager-button.input.file.label.documento-di-delega": "Documento di Delega",
      "change-submission-manager-button.input.file.upload-button.icon-aria-label.carica": "Carica",
      "change-submission-manager-button.input.file.upload-button.title.carica-documento-di-delega": "Carica Documento di Delega",
      "change-submission-manager-button.input.fiscal-code.label.codice-fiscale": "Codice Fiscale o E-Mail",
      "change-submission-manager-button.input.fiscal-code.placeholder.codice-fiscale": "Codice Fiscale o E-Mail",
      "change-submission-manager-button.message.error.nessun-id-della-richiesta-trovato": "Nessun ID della richiesta trovato",
      "change-submission-manager-button.message.error.si-e-verificato-un-errore-riprovare": "Si è verificato un errore. Riprovare.",
      "change-submission-manager-button.message.success.aggiornato-con-successo": "aggiornato con successo",
      "change-submission-manager-button.subject-name.gestore": "Gestore",
      "change-submission-manager-button.subject-name.procuratore": "Procuratore",
      "change-submission-manager-button.title-prexix.assegna-un": "Assegna un",
      "change-submission-manager-button.title-prexix.cambia": "Cambia",
      "change-submission-manager.conferma-cambio-gestore": "Conferma cambio gestore",
      "change-submission-manager.sicuro-di-voler-sostituire-il-gestore": "Sei sicuro di voler sostituire il gestore della richiesta? Una volta completata l'operazione potresti perdere la possibilità di accedere alla richiesta.",
      "common.annulla": "Annulla",
      "communications.error-sending-communication": "Si è verificato un errore durante l'invio della comunicazione",
      "communications.message": "Messaggio",
      "communications.message-placeholder": "Messaggio della comunicazione",
      "communications.sent-successfully": "Comunicazione inviata con successo",
      "compilation-guide.avvia": "Avvia",
      "compilation-guide.domanda-non-trovata-in-archivio": "Domanda non trovata in archivio: id {{submissionId}}",
      "compilation-guide.impossibile-caricare-la-guida-alla-compilazione": "Impossibile caricare la guida alla compilazione della domanda",
      "compilation-module.impossibile-caricare-i-moduli": "Impossibile caricare i Moduli della Domanda",
      "compilation-module.modulo-non-trovato": "Modulo non trovato",
      "compilation-module.modulo-salvato-con-successo": "Modulo salvato con successo",
      "comunicazioni.invia": "Invia",
      "create-request-button.error": "Errore durante la creazione della richiesta",
      "delegate-username.nessuno": "Nessuno",
      "delegati-differenti-o-mancanti": "I moduli presentano delegati differenti o mancanti",
      "delegation-column-base.delegati": "Delegati",
      "delegation-column-base.lettura": "Lettura",
      "delegation-column-base.moduli": "Moduli",
      "delegation-data-schema.abilita-compilazione": "Abilita Compilazione",
      "delegation-data-schema.abilita-firma": "Abilita Firma",
      "delegation-data-schema.abilita-invio": "Abilita Invio",
      "delegation-data-schema.codice-fiscale": "Codice Fiscale",
      "delegation-page.address-book.button-label": "Rubrica Delegati",
      "delegation-page.attorney": "Procuratore",
      "delegation-page.azioni": "Azioni",
      "delegation-page.manager": "Gestore",
      "delegation-page.title": "Gestione Deleghe",
      "delegation-page.torna-alla-richiesta": "Torna alla richiesta",
      "delegation-schema.documento-di-delega": "Documento di Delega",
      "delegation.errore": "Si è verificato un errore. Riprovare.",
      "delegation.modifica-deleghe-moduli-drawer.delega-di-compilazione": "Delega di Compilazione",
      "delegation.modifica-deleghe-moduli-drawer.delega-di-firma": "Delega di Firma",
      "delegation.modifica-deleghe-moduli-drawer.delegati": "Delegati",
      "delegation.modifica-deleghe-moduli-drawer.deleghe-aggiornate": "Deleghe aggiornate con successo",
      "delegation.modifica-deleghe-moduli-drawer.deleghe-di-visualizzazione": "Deleghe di Visualizzazione",
      "delegation.modifica-deleghe-moduli-drawer.moduli-selezionati": "Moduli Selezionati",
      "delegation.modifica-deleghe-moduli-drawer.titolo": "Gestione Deleghe Moduli",
      "delegation.page.breadcrumb.gestione-deleghe": "Gestione Deleghe",
      "delegation.page.breadcrumb.richieste": "Richieste",
      "delegation.page.button.gestisci-selezionati": "Gestisci Selezionati",
      "delegation.page.delegation-table.button.gestisci": "Gestisci",
      "delegation.page.delegation-table.checkbox.seleziona-modulo": "Seleziona modulo",
      "delegation.page.delegation-table.checkbox.seleziona-tutti-i-moduli": "Seleziona tutti i moduli",
      "delegation.page.divider-title.deleghe-dei-moduli": "Deleghe dei Moduli",
      "delegation.page.error.impossibile-caricare-le-deleghe-della-richiesta": "Impossibile caricare le deleghe della richiesta",
      "domanda-copertina.accedi": "Accedi",
      "domanda.bottone-compilare-una-richiesta-per-titolare": "È possibile compilare una sola richiesta per titolare per questa domanda",
      "domanda.bottone-crea-richiesta.sola-lettura": "Attualmente non è possibile compilare questa domanda. Si prega di riprovare in un altro orario.",
      "domanda.bottone-crea-richiesta.vai-alla-compilazione": "Vai alla compilazione",
      "domande.lista.elemento.alt-immagine.copertina-domanda": "copertina domanda",
      "domande.lista.elemento.etichetta.scadenza": "Scadenza",
      "domande.lista.elemento.pulsante.dettaglio-domanda": "Vai alla procedura",
      "domande.lista.elemento.pulsante.vai-alla-domanda": "Vai alla Domanda",
      "domande.lista.pulsante.rimuovi-filtri": "Rimuovi filtri",
      "dossier-page.errore-caricamento-pratica": "Si è verificato un errore durante il caricamento della pratica.",
      "dossiers-list.dossierss-list-title": "Elenco Pratiche",
      "edit-modules-delegation-schema.delegati-alla-visualizzazione": "Delegati alla visualizzazione",
      "edit-modules-delegation-schema.delegato-alla-compilazione": "Delegato alla compilazione",
      "edit-modules-delegation-schema.delegato-alla-firma": "Delegato alla firma",
      "errors-default.403.messaggio.non-autorizzato": "Non si dispone dei permessi per visualizzare la pagina richiesta.",
      "errors-default.403.titolo.non-autorizzato": "403 Non Autorizzato",
      "errors-default.404.messaggio.non-trovata": "Pagina Non Trovata.",
      "errors-default.404.titolo.non-trovato": "404 Non Trovato",
      "errors-default.500.messaggio.errore-interno-server": "Si è verificato un errore non previsto del server. Si prega di riprovare o contattare l'assistenza.",
      "errors-default.500.titolo.errore-interno-server": "500 Errore Interno Server",
      "errors-default.generico.messaggio.errore-network": "Sì è verificato un errore nella richiesta.",
      "errors-default.generico.titolo.errore-network": "Errore Network",
      "export.default-errore": "Si è verificato un problema durante il download del file. Riprovare.",
      "export.file": "Richieste_{{data}}.{{fileExtension}}",
      "export.file-non-trovato": "File non trovato",
      "extended-filters-schema.categorie": "Categorie",
      "extended-filters-schema.codice-fiscale-titolare": "Codice Fiscale Titolare",
      "extended-filters-schema.cognome-titolare": "Cognome Titolare",
      "extended-filters-schema.data-avvio-compilazione-a": "Data Avvio Compilazione A",
      "extended-filters-schema.data-avvio-compilazione-da": "Data Avvio Compilazione Da",
      "extended-filters-schema.data-invio-compilazione-a": "Data Invio Compilazione A",
      "extended-filters-schema.data-invio-compilazione-da": "Data Invio Compilazione Da",
      "extended-filters-schema.email-titolare": "Email Titolare",
      "extended-filters-schema.nome-titolare": "Nome Titolare",
      "extended-filters-schema.stato-delega": "Stato Delega",
      "extended-filters-schema.stato-tipo-domanda": "Stato Tipo Domanda",
      "extended-filters-schema.tipo-domanda": "Tipo Domanda",
      "extended-filters-schema.titolo-tipo-domanda": "Titolo Tipo Domanda",
      "extended-filters-schema.valori-ricerca-estesa": "Valori Ricerca Estesa",
      "folder.data": "Data",
      "folder.data-documento": "Data Documento",
      "folder.descrizione": "Descrizione",
      "folder.nome": "Nome",
      "folder.protocollo": "Protocollo",
      "folder.tipo": "Tipo",
      "form.disable-submit-tooltip": "L'invio è abilitato solo per il titolare o il procuratore.",
      "form.errore-durante-invio": "Si è verificato un errore durante l'invio",
      "form.form-cannot-send-as-delegate-tooltip": "Non puoi inviare questa richiesta in quanto la delega non permette l'invio",
      "form.form-not-completed-tooltip": "Compilazione incompleta",
      "form.form-not-payed-tooltip": "Pagamenti mancanti",
      "form.indietro": "Indietro",
      "form.invia-la-domanda": "Invia la domanda",
      "form.invio-effettuato-con-successo": "Invio effettuato con successo",
      "front-user-menu.button.aria-label": "Menu Utente",
      "front-user-menu.button.piva-label": "P.IVA {{piva}}",
      "frontoffice.legal-entity-banner.change-profile": "Cambia profilo",
      "frontoffice.legal-entity-banner.operating-as": "Stai operando per conto di",
      "frontoffice.legal-entity-banner.pg": "Persona Giuridica",
      "frontoffice.legal-entity-banner.pg-type": "Persona Giuridica {{type}}",
      "frontoffice.menu.profile.label": "Profilo",
      "frontoffice.menu.profile.title": "Accedi al Profilo",
      "handle-modules-delegation-submit.id-richiesta-non-valido": "ID richiesta non valido. Riprovare.",
      "inquiry-cover.errore-caricamento-copertina-domanda": "Impossibile caricare la copertina della domanda",
      "inquiry-cover.titolo-non-presente": "Titolo non presente",
      "inquiry.ambito": "Ambito",
      "inquiry.area-filter": "Amministrazione",
      "inquiry.categorie": "Categorie",
      "inquiry.cerca": "Cerca",
      "inquiry.destinatari": "Destinatari",
      "inquiry.destinatari-bloccato-persona-giuridica": "Filtro impostato automaticamente in base alla Persona Giuridica per cui stai operando.",
      "inquiry.filtri": "Filtri",
      "inquiry.filtri-di-ricerca": "Filtri di ricerca",
      "inquiry.in-collaudo": "In Collaudo",
      "inquiry.lista.briciole.domanda": "Domanda",
      "inquiry.lista.briciole.domande": "Domande",
      "inquiry.lista.errori.impossibile-caricare-la-sezione": "Impossibile caricare l'elenco delle domande",
      "inquiry.lista.filtri-applicati.domande-mostrate-in-base-ai-filtri-di-ricerca": "domande trovate in base ai filtri di ricerca.",
      "inquiry.lista.vuota.nessuna-domanda-da-mostrare": "Nessuna domanda da mostrare.",
      "inquiry.pubblicata": "Pubblicata",
      "inquiry.solo-attive": "Solo Attive",
      "inquiry.sotto-ambito": "Sotto Ambito",
      "inquiry.stato": "Stato",
      "inquiry.stato.aperta": "Aperta",
      "inquiry.stato.chiusa": "Chiusa",
      "inquiry.stato.in_corso": "In corso",
      "inquiry.stato.pubblicata": "Pubblicata",
      "inquiry.tipo-pubblicazione": "Tipo Pubblicazione",
      "inquiry.tipo-pubblicazione-filtro": "Pubblicazione",
      "inquiry.titolo": "Titolo",
      "inquiry.tutte-le-domande": "Tutte le Domande",
      "inserisci-cf-or-email-delegato": "Inserisci il Codice Fiscale o l'E-Mail per l'utente estero",
      "inserisci-codici-fiscali-o-email-delegati": "Inserisci i Codici Fiscali o le E-Mail per gli utenti esteri",
      "integration-rows.nessuna-richiesta-attiva": "Nessuna richiesta attiva",
      "integration-rows.nessuna-richiesta-precedente": "Nessuna richiesta precedente",
      "integration-rows.richieste-integrate": "Richieste Integrate (elenco richieste precedenti)",
      "integration-rows.ultima-integrazione-della-richiesta": "Ultima integrazione della richiesta",
      "integration.data-creazione": "Data Creazione:",
      "integration.data-invio": "Data Invio:",
      "integration.stato": "Stato:",
      "integration.vai-alla-richiesta": "Vai alla richiesta",
      "integration.vai-alla-richiesta-originale": "Vai alla richiesta originale",
      "integration.vai-elenco-integrazioni": "Vai all'elenco delle integrazioni",
      "lang-long-name.en": "Inglese",
      "lang-long-name.it": "Italiano",
      "layout.footer.vai-all-inizio-pagina": "Vai all’inizio della pagina",
      "layout.header.menu-di.passa-alla-lingua": "Passa alla lingua {{langName}}",
      "layout.header.menu-di.scelta-lingua": "Menu di scelta lingua",
      "layout.header.pulsante-notifiche_one": "{{count}} notifica da leggere",
      "layout.header.pulsante-notifiche_many": "{{count}} notifiche da leggere",
      "layout.header.pulsante-notifiche_other": "{{count}} notifiche da leggere",
      "layout.skip-links.vai-al-contenuto-principale": "Vai al contenuto principale",
      "layout.skip-links.vai-al-footer": "Vai al footer",
      "layout.skip-links.vai-al-menu-principale": "Vai al menu principale",
      "legal-entity.status-draft": "Bozza",
      "legal-entity.status-revoked": "Revocata",
      "legal-entity.status-validated": "Validata",
      "legal-entity.type-private": "Privata",
      "legal-entity.type-public": "Pubblica",
      "login-button.accedi": "Accedi",
      "main-menu.mobile.aria-label": "Menu Principale",
      "menu-items.guida-alla-compilazione": "Guida alla compilazione",
      "menu-items.riepilogo": "Riepilogo",
      "menu.category.sr-title": "Vai a Domande nella categoria {{category}}",
      "menu.istanze-archiviate": "Istanze Archiviate",
      "menu.le-mie-pratiche": "Le mie Pratiche",
      "menu.le-mie-pratiche.sr-title": "Vai a Le mie Pratiche",
      "menu.le-mie-richieste": "Le mie Richieste",
      "menu.le-mie-richieste.sr-title": "Vai a Le mie Richieste",
      "menu.principal-menu": "Menu Principale",
      "menu.tutte-le-domande": "Tutte le Domande",
      "menu.tutte-le-domande.sr-title": "Vai a Tutte le Domande",
      "modifica-tutti": "Modifica tutti",
      "module-listname.da-firmare": "Da firmare",
      "module-tooltip-text.vai-al-modulo": "Vai al modulo per correggere gli errori",
      "modules-delegations.view.abilita-deleghe": "Abilita deleghe",
      "modules-previous-delegations-summary.delegati-precedenti": "Delegati precedenti:",
      "observation-details.allegato-del-procedimento": "Allegato del Procedimento",
      "observation-details.allegato-della-richiesta": "Allegato della Richiesta",
      "observation-details.altri-titolari": "Altri Titolari",
      "observation-details.apri-cartella": "Apri cartella {{recordName}}",
      "observation-details.apri-documento": "Apri Documento {{record}}",
      "observation-details.azioni": "Azioni",
      "observation-details.chiudi-cartella": "Chiudi cartella {{recordName}}",
      "observation-details.comunicazione": "Comunicazione",
      "observation-details.dati-della-richiesta": "Dati della Richiesta",
      "observation-details.documenti": "Documenti",
      "observation-details.documento": "Documento",
      "observation-details.domanda": "Domanda",
      "observation-details.titolare": "Titolare",
      "observation.area-pubblica": "Area Pubblica",
      "observation.Cognome-titolare": "Cognome Titolare",
      "observation.data-invio": "Data invio",
      "observation.data-protocollo": "Data Protocollo",
      "observation.dati-del-procedimento": "Dati del Procedimento",
      "observation.domanda": "Domanda",
      "observation.domande-trovate-in-base-ai-filtri-di-ricerca": "domande trovate in base ai filtri di ricerca.",
      "observation.errore-durante-il-caricamento": "Si è verificato un errore durante il caricamento.",
      "observation.fine-osservazione": "Fine Osservazione",
      "observation.impossibile-caricare-elenco-area-pubblica": "Impossibile caricare l'elenco dell'Area Pubblica",
      "observation.inizio-osservazione": "Inizio Osservazione",
      "observation.numero-istanza": "Numero Istanza",
      "observation.numero-procedimento": "Numero Procedimento",
      "observation.numero-protocollo": "Numero Protocollo",
      "observation.nuova-osservazione": "Nuova Osservazione",
      "observation.oggetto": "Oggetto",
      "observation.oggetto-procedimento": "Oggetto Procedimento",
      "observation.osservabile": "Osservabile",
      "observation.periodo-osservazione": "Periodo osservazione",
      "observation.procedimento": "Procedimento",
      "observation.ricerca": "Ricerca",
      "observation.rimuovi-filtri": "Rimuovi filtri",
      "observation.stato": "Stato",
      "observation.titolare": "Titolare",
      "observation.titolo-domanda": "Titolo Domanda",
      "observation.ufficio-responsabile": "Ufficio Responsabile",
      "payment.da-pagare-dopo-invio": "Da Pagare dopo l'invio",
      "possibile-modificare-tutti-i-moduli-con-un-nuovo-delegato": "È possibile modificare tutti i moduli con un nuovo delegato",
      "pratiche.dati": "Dati",
      "pratiche.descriptions": "Dettagli Pratica",
      "pratiche.dettaglio": "Dettaglio pratica",
      "pratiche.pratiche": "Pratiche",
      "pratiche.submissions": "Richieste",
      "progressive-number-filter.anno": "Anno",
      "remove-submission-attorney-button.errore": "Si è verificato un errore. Riprovare.",
      "remove-submission-attorney-button.procuratore-rimosso-con-successo": "Procuratore rimosso con successo",
      "remove-submission-attorney-button.rimuovere-attuale-procuratore": "Rimuovere l'attuale procuratore?",
      "remove-submission-attorney-button.rimuovi-procuratore": "Rimuovi Procuratore",
      "reply-communication.create-error": "Impossibile creare la risposta",
      "reply-communication.created": "Risposta creata con successo",
      "reply-communication.recipient": "Destinatario",
      "reply-communication.title": "Rispondi alla comunicazione",
      "richieste.firma.carica-documento-firmato-per-continuare": "Carica un documento firmato per continuare",
      "richieste.firma.carica-e-completa": "Carica e Completa",
      "richieste.firma.messaggio-errore-caricamento-file": "Errore durante il caricamento del file, riprovare",
      "richieste.firma.messaggio-successo-caricamento-file": "Il modulo firmato è stato caricato correttamente.",
      "richieste.firma.procedura-firma-modulo": "Procedura di Firma Modulo",
      "richieste.firma.scaricare-il-modulo-per-procedere-alla-firma": "Scaricare il modulo <title/>, procedere alla firma digitale e ricaricare il modulo firmato.",
      "selected-modules-text.moduli-selezionati": "{{selectedRows}} moduli selezionati",
      "selected-modules-text.un-modulo-selezionato": "1 modulo selezionato",
      "shared-resource.document-id": "ID documento",
      "shared-resource.file-open": "Apri",
      "shared-resource.files": "File allegati",
      "shared-resource.load-error": "Non è stato possibile recuperare le informazioni del documento.",
      "shared-resource.metadata": "Metadati",
      "shared-resource.no-files": "Nessun file disponibile per il download",
      "shared-resource.page-title": "Informazioni del documento",
      "shared-resource.portal-title": "Portale dei procedimenti e dei servizi al cittadino",
      "signed-module.documento-modulo-firmato": "Documento Modulo Firmato",
      "signed-module.errore-in-download-file": "Si è verificato un problema durante il download del file. Riprovare.",
      "signed-module.file-non-trovato": "File non trovato",
      "submission-action-button.carica-documento-firmato-per-continuare": "Carica un documento firmato per continuare",
      "submission-action-button.compilazione-terminata": "Compilazione terminata",
      "submission-action-button.conferma-firma": " Conferma Firma",
      "submission-action-button.errore": "Si è verificato un errore: riprovare",
      "submission-action-button.firma-delegata": "La firma è delegata ad un altro utente.",
      "submission-action-button.in-attesa-compilazione-delegato": "In attesa della compilazione da parte del delegato.",
      "submission-action-button.modulo-compilato": "Il modulo è stato compilato.",
      "submission-action-button.modulo-compilato-e-firmato": "Il modulo è stato compilato e firmato. Riportando il modulo in compilazione, sarà necessario firmarlo nuovamente.",
      "submission-action-button.modulo-compilato-e-firmato-precedentemente": "Il modulo è già stato compilato e firmato.",
      "submission-action-button.modulo-compilato-precedentemente": "Il modulo è già stato compilato.",
      "submission-action-button.modulo-compilato-ritornare-in-compilazione-per-modificare": "Il modulo è stato compilato, puoi ritornare in compilazione se sono necessarie modifiche.",
      "submission-action-button.modulo-completato": "Modulo completato",
      "submission-action-button.modulo-non-valido": "Il modulo non è valido",
      "submission-action-button.modulo-nuovamente-compilabile": "Modulo nuovamente compilabile",
      "submission-action-button.modulo-pronto-per-la-firma": "Modulo pronto per la firma",
      "submission-action-button.per-procedere-alla-firma-segnare-come-pronto": "Per procedere alla firma segnare il modulo come Pronto per la firma.",
      "submission-action-button.pronto-per-la-firma": "Pronto per la firma",
      "submission-action-button.ritorna-in-compilazione": "Ritorna in compilazione",
      "submission-action-button.salva-modulo": "Salva il modulo per continuare",
      "submission-action-button.se-completato-il-modulo-premi-compilazione-terminata": "Se hai completato il modulo, premi il pulsante Compilazione terminata.",
      "submission-clone-button.chiudi": "Chiudi",
      "submission-clone-button.duplica": "Duplica",
      "submission-clone-button.duplica-richiesta": "Duplica la Richiesta",
      "submission-clone-button.errore-durante-la-duplicazione-della-richiesta": "Si è verificato un errore durante la duplicazione della richiesta.",
      "submission-clone-button.errore-nel-duplicare-la-richiesta": "Errore nel duplicare la richiesta",
      "submission-clone-button.la-richiesta-deve-essere-salvata-per-duplicare": "La richiesta deve essere salvata per poter essere duplicata.",
      "submission-clone-button.la-richiesta-verra-duplicata-senza-i-file-allegati": "La richiesta verrà duplicata senza i file allegati.",
      "submission-clone-button.richiesta-duplicata-con-successo": "Richiesta duplicata con successo.",
      "submission-clone-button.sei-sicuro-di-voler-duplicare-la-richiesta": "Sei sicuro di voler duplicare la richiesta?",
      "submission-columns.bozza": "Bozza",
      "submission-columns.conclusa": "Conclusa",
      "submission-columns.creata": "Creata",
      "submission-columns.data-creazione": "Data creazione",
      "submission-columns.data-invio": "Data invio",
      "submission-columns.data-modifica": "Data modifica",
      "submission-columns.domanda": "Domanda",
      "submission-columns.fase": "Fase",
      "submission-columns.integrata": "Integrata",
      "submission-columns.inviata": "Inviata",
      "submission-columns.numero-istanza": "Numero Istanza",
      "submission-columns.numero-protocollo": "Numero Protocollo",
      "submission-columns.oggetto": "Oggetto",
      "submission-columns.ricevuta": "Ricevuta",
      "submission-columns.stato": "Stato",
      "submission-columns.titolare": "Titolare",
      "submission-delegation-drawer.abilita-compilazione-della-richiesta": "Abilita alla compilazione della richiesta",
      "submission-delegation-drawer.abilita-firma-della-richiesta": "Abilita alla firma della richiesta",
      "submission-delegation-drawer.abilita-invio-della-richiesta": "Abilita invio della richiesta",
      "submission-delegation-drawer.annulla": "Annulla",
      "submission-delegation-drawer.carica-documento-di-delega": "Carica Documento di Delega",
      "submission-delegation-drawer.codice-fiscale-partita-iva": "Codice Fiscale/Partita IVA",
      "submission-delegation-drawer.delega-inviata-con-successo": "Delega inviata con successo",
      "submission-delegation-drawer.delega-richiesta": "Delega Richiesta",
      "submission-delegation-drawer.documento-di-delega": "Documento di Delega",
      "submission-delete-delegation-button.codice-fiscale-delegato": "Delegato: {{delegateFiscalCode}}",
      "submission-delete-delegation-button.delega-rimossa-con-successo": "Delega rimossa con successo",
      "submission-delete-delegation-button.rimuovi-delega": "Rimuovi delega",
      "submission-delete-delegation-button.sicuro-di-voler-rimuovere-delega": "Sei sicuro di voler rimuovere questa delega?",
      "submission-details.comunicazioni": "Comunicazioni",
      "submission-details.comunicazioni-aria-label": "Comunicazioni. Tab {{tabNumber}} di {{totalTabs}}",
      "submission-details.integrazioni": "Integrazioni",
      "submission-details.integrazioni-aria-label": "Integrazioni. Tab {{tabNumber}} di {{totalTabs}}",
      "submission-details.la-mia-richiesta": "La mia richiesta",
      "submission-details.la-mia-richiesta-aria-label": "La mia richiesta. Tab {{tabNumber}} di {{totalTabs}}",
      "submission-details.pagamenti": "Pagamenti",
      "submission-details.pagamenti-aria-label": "Pagamenti. Tab {{tabNumber}} di {{totalTabs}}",
      "submission-details.ricevuta-invio": "Ricevuta invio",
      "submission-details.ricevuta-invio-aria-label": "Ricevuta invio. Tab {{tabNumber}} di {{totalTabs}}",
      "submission-filter-form-mobile.codice-fiscale-titolare": "Codice Fiscale Titolare",
      "submission-filter-form-mobile.cognome-titolare": "Cognome Titolare",
      "submission-filter-form-mobile.nome-titolare": "Nome Titolare",
      "submission-filter.categorie": "Categorie",
      "submission-filter.codice-fiscale-titolare": "Codice Fiscale Titolare",
      "submission-filter.cognome-titolare": "Cognome Titolare",
      "submission-filter.nome-titolare": "Nome Titolare",
      "submission-filter.ricerca-estesa": "Ricerca Estesa",
      "submission-filter.seleziona-le-categorie": "Seleziona le categorie",
      "submission-filter.stato-delega": "Stato Delega",
      "submission-form.compilazione-richiesta-incompleta": "Compilazione richiesta incompleta",
      "submission-form.errore-in-caricamento-domanda": "Si è verificato un errore durante il caricamento della domanda.",
      "submission-form.errore-in-caricamento-richiesta": "Si è verificato un errore durante il caricamento della richiesta.",
      "submission-form.errore-moduli-incompleti-per-poter-procedere": "Alcuni moduli risultano incompleti o presentano errori. È necessario compilare tutti i moduli per procedere all'invio della richiesta.",
      "submission-form.errore-oneri-non-pagati-per-poter-procedere": "Alcuni oneri risultano non pagati. È necessario compilare tutti gli oneri obbligatori per procedere all'invio della richiesta.",
      "submission-form.id-della-richiesta-non-valido": "ID della richiesta non valido",
      "submission-form.integrazione-di-un-altra-richiesta": "Questa è un'integrazione di un'altra richiesta.",
      "submission-form.inviare-per-procedere-al-pagamento": "Procedere all'invio della Richiesta per effettuare il pagamento degli oneri.",
      "submission-form.invio-in-corso": "Invio in corso...",
      "submission-form.richieste": "Richieste",
      "submission-form.stato-pagamenti-incompleto": "Stato pagamenti incompleto",
      "submission-integration-button.avvia": "Avvia",
      "submission-integration-button.integra-la-richiesta": "Integra la Richiesta",
      "submission-integration-button.sicuro-avviare-integrazione": "Sicuro di voler avviare l'integrazione?",
      "submission-linked-button.visualizza-richiesta": "Visualizza richiesta",
      "submission-list.apri-pagina-dettaglio-richiesta": "Apri la pagina di dettaglio della richiesta",
      "submission-list.domande-trovate-in-base-ai-filtri": "domande trovate in base ai filtri di ricerca.",
      "submission-list.duplica-richiesta": "Duplica richiesta",
      "submission-list.errore-eliminazione-richiesta": "Errore durante l'eliminazione della richiesta",
      "submission-list.header-col.actions": "Azioni",
      "submission-list.impossibile-caricare-elenco-richieste": "Impossibile caricare l'elenco delle Richieste",
      "submission-list.richiesta-eliminata-con-successo": "Richiesta eliminata con successo",
      "submission-list.richieste": "Richieste",
      "submission-list.rimuovi-filtri": "Rimuovi filtri",
      "submission-list.search": "Ricerca",
      "submission-list.submissions-list-title": "Elenco Richieste",
      "submission-list.visualizza-richiesta": "Visualizza richiesta",
      "submission-module.il-gestore": "il Gestore",
      "submission-module.il-procuratore": "il Procuratore",
      "submission-module.il-titolare": "il Titolare",
      "submission-module.modulo-completato": "Il modulo è completato.",
      "submission-module.modulo-disponibile-alla-firma-al-termine-della-compilazione": "Il modulo sarà disponibile per la firma al termine della compilazione.",
      "submission-module.necessario-compilare-il-modulo": "È necessario compilare il modulo.",
      "submission-module.necessario-firmare-il-modulo": "È necessario firmare il modulo.",
      "submission-module.permesso-utente-modulo": "Hai il permesso per <permissionsText/> questo\n          Modulo.",
      "submission-module.riepilogo-modulo": "Riepilogo Modulo",
      "submission-module.ruolo-utente-della-richiesta": "Sei <roleText/> della Richiesta.",
      "submission-module.stai-visualizzando-in-sola-lettura-il-modulo": "Stai visualizzando in sola lettura questo modulo.",
      "submission-module.un-delegato": "un Delegato",
      "submission-payment.conferma-a-procedere": "Si è sicuri di voler procedere?",
      "submission-payment.rieffettuare-il-pagamento-a-seguito-di-riportare-in-bozza": "Riportando la richiesta in bozza, tutti <bold>i bolli pagati verranno invalidati</bold> e sarà necessario effettuare di nuovo il pagamento.",
      "submission-payments.annulla-pagamenti-e-torna-in-bozza": "Annulla pagamenti e ritorna in bozza",
      "submission-payments.errore": "Si è verificato un errore durante la modifica dello stato della richiesta",
      "submission-payments.inviare-o-riportare-in-bozza": "La tua richiesta è stata pagata. È possibile inviarla, altrimenti è possibile riportarla in bozza per apportare modifiche, annullando i bolli pagati.",
      "submission-payments.pagare-o-riportare-in-bozza": "La tua richiesta è in pagamento. Una volta pagati i bolli è possibile inviarla, altrimenti è possibile riportarla in bozza per apportare modifiche.",
      "submission-payments.riporta-in-bozza": "Riporta in bozza",
      "submission-searchable-fields.anno-istanza": "Anno Istanza",
      "submission-searchable-fields.bozza": "Bozza",
      "submission-searchable-fields.categoria": "Categoria",
      "submission-searchable-fields.codice-fiscale-titolare": "Codice Fiscale Titolare",
      "submission-searchable-fields.cognome-titolare": "Cognome Titolare",
      "submission-searchable-fields.conclusa": "Conclusa",
      "submission-searchable-fields.data-avvio-compilazione-al": "Data avvio compilazione al",
      "submission-searchable-fields.data-avvio-compilazione-dal": "Data avvio compilazione dal",
      "submission-searchable-fields.data-creazione": "Data creazione",
      "submission-searchable-fields.data-invio": "Data invio",
      "submission-searchable-fields.data-invio-al": "Data invio al",
      "submission-searchable-fields.data-invio-dal": "Data invio dal",
      "submission-searchable-fields.integrata": "Integrata",
      "submission-searchable-fields.inviata": "Inviata",
      "submission-searchable-fields.nome-titolare": "Nome Titolare",
      "submission-searchable-fields.numero-istanza": "Numero Istanza",
      "submission-searchable-fields.oggetto": "Oggetto",
      "submission-searchable-fields.ricerca-estesa": "Ricerca Estesa",
      "submission-searchable-fields.ricevuta": "Ricevuta",
      "submission-searchable-fields.seleziona-le-categorie": "Seleziona le categorie",
      "submission-searchable-fields.stato-delega": "Stato Delega",
      "submission-searchable-fields.stato-richiesta": "Stato Richiesta",
      "submission-searchable-fields.tipo-domanda": "Tipo Domanda",
      "submission-searchable-fields.titolo-tipo-domanda": "Titolo Tipo Domanda",
      "submission-sent-form.apri-integrazione-in-bozza": "Apri Integrazione in Bozza",
      "submission-sent-form.errore-in-caricamento-domanda": "Si è verificato un errore durante il caricamento della domanda.",
      "submission-sent-form.errore-in-caricamento-richiesta": "Si è verificato un errore durante il caricamento della richiesta.",
      "submission-sent-form.errore-in-integrazione-richiesta": "Si è verificato un errore durante l'integrazione della richiesta, si prega di riprovare.",
      "submission-sent-form.id-della-richiesta-non-valido": "ID della richiesta non valido",
      "submission-sent-form.integrazione-creata-con-successo": "Integrazione creata con successo",
      "submission-sent-form.integrazione-di-un-altra-richiesta": "Questa è un'integrazione di un'altra richiesta.",
      "submission-sent-form.integrazione-in-bozza": "È presente una bozza di integrazione per questa richiesta.",
      "submission-sent-form.richiesta-integrata": "Questa richiesta è stata integrata.",
      "submission-sent-form.richieste": "Richieste",
      "submission-sent-form.tabs-row.aria": "Navigazione tra le schede della richiesta inviata",
      "submission-sent-tab-communications.comunicazione-creata-con-successo": "Comunicazione creata con successo",
      "submission-sent-tab-communications.comunicazione-eliminata-con-successo": "Comunicazione eliminata con successo",
      "submission-sent-tab-communications.comunicazione-modificata-con-successo": "Comunicazione modificata con successo",
      "submission-sent-tab-communications.comunicazioni-trovate-in-base-ai-filtri": "comunicazioni trovate in base ai filtri di ricerca.",
      "submission-sent-tab-communications.errore-caricamento-allegato": "Impossibile caricare l'allegato",
      "submission-sent-tab-communications.errore-caricamento-comunicazioni": "Impossibile caricare le comunicazioni",
      "submission-sent-tab-communications.errore-creazione-comunicazione": "Impossibile creare la comunicazione",
      "submission-sent-tab-communications.errore-eliminazione-comunicazione": "Impossibile eliminare la comunicaizone",
      "submission-sent-tab-communications.errore-modifica-comunicazione": "Impossibile modificare la comunicazione",
      "submission-sent-tab-communications.errore-rimozione-allegato": "Impossibile rimuovere l'allegato",
      "submission-sent-tab-communications.errore-tab-comunicazioni": "Si è verificato un errore",
      "submission-sent-tab-communications.nuova-comunicazione": "Nuova Comunicazione",
      "submission-sent-tab-communications.panel-aria": "Tab delle comunicazioni della richiesta",
      "submission-sent-tab-communications.rimuovi-filtri": "Rimuovi filtri",
      "submission-sent-tab-integrations.panel-aria": "Tab Integrazioni della richiesta",
      "submission-sent-tab-payment.panel-aria": "Tab Pagamenti della richiesta",
      "submission-sent-tab-recipt.panel-aria": "Tab Ricevuta invio della richiesta",
      "submission-sent-tab-sent-request.panel-aria": "Tab richiesta inviata",
      "submission-summary.riepilogo-richiesta": "Riepilogo della Richiesta",
      "submission-summary.stato-oneri": "Stato Pagamenti",
      "submission.altri-titolari": "Altre parti interessate",
      "submission.button.button-delete-modal.elimina-richiesta": "Elimina richiesta",
      "submission.button.button-delete-modal.la-richiesta-deve-essere-salvata-per-essere-eliminata": "La richiesta deve essere salvata per poter essere eliminata.",
      "submission.button.button-delete-modal.modal-button.chiudi": "Chiudi",
      "submission.button.button-delete-modal.sei-sicuro-di-voler-eliminare-la-richiesta": "Sei sicuro di voler eliminare la richiesta?",
      "submission.codice-richiesta": "Codice richiesta:",
      "submission.data-invio": "Data invio:",
      "submission.data-protocollo": "Data protocollo:",
      "submission.delegation-banner.stai-commpilando-in-delega-la-richiesta": "Stai visualizzando questa richiesta come delegato.",
      "submission.delegation-button": "Delega la Richiesta",
      "submission.documento-firmato": "Documento Firmato",
      "submission.numero-procedimento": "Numero procedimento:",
      "submission.numero-protocollo": "Numero protocollo:",
      "submission.oggetto-richiesta": "Oggetto:",
      "submission.richiesta-inviata-con-successo": "Richiesta inviata con successo!",
      "submission.richiesta-inviata-correttamente-da-prendere-in-carico": "La richiesta è stata inviata correttamente e sarà presa in carico a breve.",
      "submission.salva-modulo-per-caricare-file-firmato": "Salva il modulo per caricare il file firmato",
      "submission.seleziona-file-firmato": "Seleziona file firmato...",
      "submission.stato-richiesta": "Stato richiesta:",
      "submission.vai-ai-pagamenti": "Vai alla sezione \"Pagamenti\" per visualizzare e gestire il preventivo",
      "tag-options.delegato": "Delegato",
      "tag-options.gestore": "Gestore",
      "tag-options.procuratore": "Procuratore",
      "tag-options.titolare": "Titolare",
      "tag-options.utente": "Utente",
      "ui.apri-pannello-ricerca": "Apri pannello di ricerca",
      "ui.cerca": "Cerca",
      "ui.filtri-di-ricerca": "Filtri di ricerca",
      "ui.nessun-filtro-modificato": "Nessun filtro modificato",
      "ui.rimuovi-filtri": "Rimuovi Filtri",
      "update-delegation-data-schema.abilita-delega": "Abilita delega",
      "update-delegation-data-schema.conferma-modifica": "Conferma Modifica",
      "update-delegation-data-schema.delegato": "Delegato",
      "user-profile-nationality.EU": "Paesi eIDAS",
      "user-profile-nationality.extra-EU": "Altri Paesi",
      "user-profile-nationality.italy": "Italiana",
      "user-registration-form.divider-title": "Dati anagrafici",
      "user-registration-form.email": "Email",
      "user-registration-form.nationality": "Nazionalità",
      "user-registration-form.nationaly-eidas-help": "È possibile consultare <2>l'elenco dei paesi che supportano il Login eIDAS per l'Italia</2>.",
      "user-registration-form.password": "Password",
      "user-registration-form.password-confirm": "Conferma Password",
      "user-registration-form.password-confirm-error": "Le password non coincidono.",
      "user-registration-form.profile.agreement": "Consenso",
      "user-registration-form.profile.country": "Paese di provenienza",
      "user-registration-form.profile.country-of-birth": "Provincia di Nascita",
      "user-registration-form.profile.county-of-birth": "Provincia di Nascita",
      "user-registration-form.profile.date-of-birth": "Data di Nascita",
      "user-registration-form.profile.familyName": "Cognome",
      "user-registration-form.profile.fiscal-number": "Codice Fiscale",
      "user-registration-form.profile.mobile-phone": "Telefono Cellulare",
      "user-registration-form.profile.name": "Nome",
      "user-registration-form.profile.place-of-birth": "Luogo di Nascita",
      "user-registration-form.profile.privacy-policy": "È necessario accettare la privacy policy",
      "user-registration-form.top-title": "Dati di accesso",
      "user-registration.back-to-login": "Ritorna al login",
      "user-registration.country.unkown": "Sconosciuto",
      "user-registration.form.privacy-acceptance": "Consenso",
      "user-registration.form.submit-button": "Registrati",
      "user-registration.ue-citizen-message": "Sei un cittadino italiano o UE? Effettua il login con SPID/CIE o eIDAS.",
      "user.activation.breadcrumb": "Attivazione Utente",
      "user.activation.error.id": "Id attivazione non valido",
      "user.activation.error.token": "Token non valido",
      "user.activation.response.error.back-button": "Torna al Login",
      "user.activation.response.error.sub-title": "Non è stato possibile verificare l'email.",
      "user.activation.response.error.title": "Errore nella verifica dell'email",
      "user.activation.response.success.sub-title": "Effettua l'accesso con email e password inserite nel modulo di registrazione.",
      "user.activation.response.success.submit-button": "Vai al Login",
      "user.activation.response.success.title": "Registrazione completata!",
      "user.activation.submit-button": "Attiva Utente",
      "user.activation.text": "Premi sul pulsante di seguito per completare la verifica della tua E-Mail.",
      "user.activation.title": "Verifica E-Mail",
      "user.breadcrumb.profilo": "Profilo",
      "user.card-title.profilo-utente": "Profilo Utente",
      "user.change-password": "Cambia Password",
      "user.conferma-password": "Conferma Password",
      "user.current-password": "Password Attuale",
      "user.errore-in-verifica-mail": "Errore nella verifica dell'email",
      "user.forgot-password.api-error-generic": "Si è verificato un errore durante il recupero della password. Riprovare",
      "user.forgot-password.breadcrumb": "Reimposta password",
      "user.forgot-password.button-text": "Inviami un'email",
      "user.forgot-password.text": "Inserisci l’email con cui ti sei registrato. Riceverai via email il link per reimpostare la password.",
      "user.forgot-password.title": "Hai dimenticato la password?",
      "user.front-login.select-pg.act-as": "Operare per conto di {{name}}",
      "user.front-login.select-pg.back-to-login": "Torna al login",
      "user.front-login.select-pg.breadcrumb": "Accedi come",
      "user.front-login.select-pg.generic-error": "Si è verificato un errore. Riprovare.",
      "user.front-login.select-pg.page-title": "Scegli con quale identità accedere.",
      "user.front-login.select-pg.self-option": "Me stesso",
      "user.front-login.select-pg.self-subtitle": "Accedi come persona fisica",
      "user.front-login.select-pg.session-expired": "Sessione scaduta. Effettuare nuovamente il login.",
      "user.front-login.select-pg.subtitle": "Seleziona il profilo con cui desideri operare",
      "user.front-login.select-pg.title": "Accedi come",
      "user.front-login.select-pg.vat-number": "P.IVA:",
      "user.le-password-non-coincidono": "Le password non coincidono.",
      "user.new-password": "Nuova Password",
      "user.password": "Password",
      "user.password-change.breadcrumb": "Cambia Password",
      "user.password-change.error.message": "Non è stato possibile cambiare la password.",
      "user.password-change.form.password-confirm": "Conferma Password",
      "user.password-change.form.password-repeat": "Ripeti Password",
      "user.password-change.form.submit-button": "Cambia Password",
      "user.password-change.response.error.sub-title": "Non è stato possibile reimpostare la password.",
      "user.password-change.response.error.title": "Errore nel cambio della password",
      "user.password-change.response.success.back-to-inquiry": "Torna alle Domande",
      "user.password-change.response.success.submit-button": "Torna al Profilo",
      "user.password-change.response.success.title": "Password modificata con successo",
      "user.password-change.success": "Password modificata",
      "user.password-change.text": "Inserisci la nuova password per l'utente",
      "user.password-change.title": "Modifica password",
      "user.password-reset-request.response.success.button-login": "Torna al Login",
      "user.password-reset-request.response.success.subtitle": "Controlla la tua casella e-mail. Ti abbiamo inviato un’email con le istruzioni per reimpostare la password.",
      "user.password-reset-request.response.success.title": "Richiesta modifica password inviata",
      "user.password-reset.breadcrumb": "Reimposta Password",
      "user.password-reset.error.id": "Id di verifica non valido",
      "user.password-reset.error.message": "Non è stato possibile reimpostare la password.",
      "user.password-reset.error.token": "Token non valido",
      "user.password-reset.form.password-confirm": "Ripeti Password",
      "user.password-reset.form.submit-button": "Reimposta Password",
      "user.password-reset.response.error.sub-title": "Non è stato possibile reimpostare la password.",
      "user.password-reset.response.error.title": "Errore nel reset della password",
      "user.password-reset.response.success.button-login": "Effettua il Login",
      "user.password-reset.response.success.submit-button": "Torna al Login",
      "user.password-reset.response.success.title": "Password reimpostata correttamente!",
      "user.password-reset.success": "Password reimpostata correttamente!",
      "user.password-reset.text": "Inserisci la nuova password per l'utente",
      "user.password-reset.title": "Reimposta password",
      "user.profile.form.submit-button": "Salva Modifiche",
      "user.profile.legal-entity.business-name": "Ragione sociale",
      "user.profile.legal-entity.pec": "PEC",
      "user.profile.legal-entity.registered-office": "Sede legale",
      "user.profile.legal-entity.section-title": "Dati Persona Giuridica",
      "user.profile.legal-entity.status": "Stato",
      "user.profile.legal-entity.type": "Tipo",
      "user.profile.legal-entity.vat-number": "P.IVA",
      "user.profile.operator.email": "Email",
      "user.profile.operator.family-name": "Cognome",
      "user.profile.operator.name": "Nome",
      "user.profile.operator.section-title": "Dati operatore",
      "user.profile.update-error": "Errore durante l'aggiornamento del profilo utente.",
      "user.profile.update-success": "Profilo utente aggiornato con successo.",
      "user.registration.breadcrumb": "Registrazione Utente",
      "user.registration.email-validation.message": "Ciao <1>{{fullName}}</1>, l’autenticazione è andata a buon fine. Inserisci la tua eMail per completare il profilo e procedere con l’accesso ai servizi online.",
      "user.registration.email-validation.response.success.sub-title-generic": "Per attivare l’utente segui le istruzioni che ti abbiamo inviato via email.",
      "user.registration.email-validation.response.success.title": "Registrazione effettuata con successo!",
      "user.registration.form.privacy-acceptance-text": "Acconsento al trattamento dei dati personali",
      "user.registration.form.submit-button": "Registrati",
      "user.registration.form.top-title": "Dati di accesso",
      "user.registration.response.error.message": "Si è verificato un errore durante la registrazione",
      "user.registration.response.success.sub-title": "Ti abbiamo inviato una mail con le istruzioni per attivare il tuo account. Una volta attivato, potrai effetturare il login sul portale.",
      "user.registration.response.success.submit-button": "Torna alle Domande",
      "user.registration.response.success.title": "Registrazione completata!",
      "verification-labels.click-sul-pulsante-per-completare-l-verifica": "Per completare la verifica fare click sul pulsante",
      "verification-labels.click-sul-pulsante-per-completare-la-verifica": "Per completare la verifica dell'email fare click sul pulsante",
      "verification-labels.verifica": "Verifica",
      "verification-labels.verifica-email": "Verifica Email",
      "verification-page.errore-durante-la-verifica": "Si è verificato un problema durante la verifica",
      "verification-page.errore-in-verifica": "Errore durante la verifica",
      "verification-page.verifica": "Verifica",
      "verification-result-info.errore-in-verifica": "Errore in verifica",
      "verification-result-info.verifica-completata-con-successo": "Verifica completata con successo",
      "verification-result-info.verifica-completata-con-warning": "Verifica completata con warning",
      "collapse.search-collapse-container.header": "Pannello di Ricerca Estesa",
      "task-card.outcomes.title": "Esiti",
      "task.payment-type.taxable": "Imponibile",
      "task.payment-type.total": "Totale",
      "task.payment-type.vat": "IVA",
      "verification.c020.breadcrumb": "Accertamento Residenza",
      "verification.c020.form.citizenRegistry": "Ricerca per Anagrafica del Cittadino",
      "verification.c020.form.citizenRegistry.label.cognome": "Cognome",
      "verification.c020.form.citizenRegistry.label.datiNascita.dataEvento": "Data di Nascita",
      "verification.c020.form.citizenRegistry.label.datiNascita.luogoNascita.comune": "Comune di Nascita",
      "verification.c020.form.citizenRegistry.label.datiNascita.luogoNascita.localita": "Stato di Nascita",
      "verification.c020.form.citizenRegistry.label.datiNascita.luogoNascita.provincia": "Sigla Provincia",
      "verification.c020.form.citizenRegistry.label.luogoNascita.locationType": "Tipo Luogo Nascita",
      "verification.c020.form.citizenRegistry.label.nome": "Nome",
      "verification.c020.form.citizenRegistry.label.sesso": "Sesso",
      "verification.c020.form.fiscalCodeSearch": "Ricerca per Codice Fiscale",
      "verification.c020.form.fiscalCodeSearch.label.codiceFiscale": "Codice Fiscale",
      "verification.c020.form.idANPRSearch": "Ricerca per ID ANPR",
      "verification.c020.form.idANPRSearch.label.idANPR": "ID ANPR",
      "verification.c020.label.scelta-tipo-di-verifica": "Scelta tipo di verifica:",
      "verification.c020.page.title": "Accertamento Residenza",
      "verification.c020.radio.option.per-anagrafica-del-cittadino": "Per anagrafica del cittadino",
      "verification.c020.radio.option.per-codice-fiscale": "Per Codice Fiscale",
      "verification.c020.radio.option.per-id-anpr": "Per ID ANPR",
      "scope.ambito-modificato-con-successo": "Ambito modificato con successo",
      "scope.errore-in-modifica-ambito": "Si è verificato un errore durante la modifica dell'Ambito",
      "array.max": "Il campo ${path} deve avere al massimo ${max} elementi",
      "array.min": "Il campo ${path} deve avere almeno ${min} elementi",
      "mixed.default": "Il campo ${path} non è valido",
      "mixed.defined": "Il campo ${path} è un campo richiesto",
      "mixed.notNull": "Il campo ${path} non può essere lasciato vuoto",
      "mixed.notOneOf": "Il campo ${path} non deve avere uno dei seguenti valori: ${values}",
      "mixed.oneOf": "Il campo ${path} deve avere uno dei seguenti valori: ${values}",
      "mixed.required": "Il campo ${path} è un campo richiesto",
      "notType.default": "Il campo {{path}} non è valido",
      "notType.number": "Il campo {{path}} deve essere un numero",
      "notType.string": "Il campo {{path}} deve essere una stringa",
      "number.integer": "Il campo ${path} deve essere un numero intero",
      "number.lessThan": "Il campo ${path} deve essere minore di ${less}",
      "number.max": "Il campo ${path} deve essere minore o uguale di ${max}",
      "number.min": "Il campo ${path} deve essere maggiore o uguale di ${min}",
      "number.moreThan": "Il campo ${path} deve essere maggiore di ${more}",
      "number.negative": "Il campo ${path} deve essere un numero negativo",
      "number.positive": "Il campo ${path} deve essere un numero positivo",
      "string.email": "Il campo ${path} deve essere una email valida",
      "string.length": "Il campo ${path} deve avere esattamente ${length} caratteri",
      "string.lowercase": "Il campo ${path} deve contenere solamente caratteri minuscoli",
      "string.matches": "Il campo ${path} deve seguire il seguente pattern: \"${regex}\"",
      "string.max": "Il campo ${path} deve avere al massimo ${max} caratteri",
      "string.min": "Il campo ${path} deve avere almeno ${min} caratteri",
      "string.trim": "Il campo ${path} deve essere un testo senza spazi iniziali o finali",
      "string.uppercase": "Il campo ${path} deve contenere solamente caratteri maiuscoli",
      "string.url": "Il campo ${path} deve essere un URL valido",
      "advanced-search.collapse-form-messagge": "risultati trovati in base ai filtri di ricerca.",
      "advanced-search.filtri": "Filtri",
      "advanced-search.remove-filters": "Rimuovi filtri",
      "advanced-search.tag-semantici": "Altri campi specializzati",
      "alert.alert-error-body.message": "Sì è verificato un errore nella richiesta.",
      "alert.error-result-body.message": "Sì è verificato un errore nella richiesta.",
      "alert.error-result-body.title": "Errore Network",
      "alert.forbidden-body.message": "Non si dispone dei permessi per visualizzare la pagina richiesta.",
      "alert.forbidden-body.title": "403 Non Autorizzato",
      "alert.internal-error-body.subtitle": "Si è verificato un errore non previsto del server. Si prega di riprovare o contattare l'assistenza.",
      "alert.internal-error-body.title": "500 Errore Interno del Server",
      "alert.not-found-body.subtitle": "Pagina Non Trovata.",
      "alert.not-found-body.title": "404 Non Trovato",
      "button.button-delete-confirm.content": "Elimina",
      "button.button-delete-confirm.icon-aria": "Elimina elemento",
      "button.button-delete-confirm.ok": "Elimina",
      "button.button-delete-confirm.title": "Sei sicuro di voler eliminare questo elemento?",
      "button.button-delete-confirm.tooltip": "Elimina elemento",
      "button.confirm-button.cancel": "Annulla",
      "button.confirm-button.confirm": "Conferma",
      "button.confirm-button.title": "Sei sicuro di voler continuare con l'operazione?",
      "button.content-hover-edit": "Modifica",
      "button.content-hover-edit-config-mode": "Modifica",
      "card.network-responsive-card.error": "Errore",
      "collapse.collapsible-area.hidden-header": "Collapsible Area",
      "collapse.desktop-filter-panel.title": "Filtri di ricerca estesi",
      "collapse.filter-button.content": "Ricerca Estesa",
      "collapse.filter-button.tooltip": "Filtri di ricerca attivi",
      "collapse.filter-button.tooltip-aria": "Filtri di ricerca attivi",
      "collapse.filter-panel.clear": "Pulisci",
      "collapse.filter-panel.search": "Cerca",
      "collapse.filtri-di-ricerca": "Filtri di Ricerca",
      "collapse.ghost-collapse.header": "Ghost Extend Collapse",
      "common.paginazione.aria-label": "Paginazione",
      "common.paginazione.precedente": "Vai alla pagina precedente",
      "common.paginazione.successiva": "Vai alla pagina successiva",
      "countdown-humanized.days": "giorni",
      "countdown-humanized.label": "Tempo rimanente",
      "countdown-humanized.label.dd": "gg",
      "countdown-humanized.label.hh": "hh",
      "countdown-humanized.label.mm": "mm",
      "countdown-humanized.label.ss": "ss",
      "countdown-humanized.more-months": "Più di due mesi",
      "countdown-humanized.more-years": "Più di un anno",
      "countdown-humanized.sr-text": "{{dd}} giorni, {{hh}} ore, {{mm}} minuti, {{ss}} secondi",
      "drawer.close-aria": "Chiudi Pannello",
      "dropdown.risultati-per-ricerca": "Risultati per \"{{search}}\"",
      "dropdown.search-dropdown.no-reseults": "Nessun risultato trovato",
      "dropdown.search-dropdown.search": "Scrivi per iniziare a cercare",
      "file-row.file-uploaded-prefix": "File caricato: ",
      "html.head.title": "Portale dei Procedimenti | Frontoffice",
      "layout.page-layout-base.top-bar-aria": "Vai all’inizio della pagina",
      "loader.loader-spin.icon-aria": "Caricamento...",
      "message-filtered-list.invisible.sr-default-message": "Nessun filtro applicato",
      "moddal.modal-confirm.delete": "Elimina",
      "route-announcer.nav-to-page": "Navigato a {{title}}",
      "router.breadcrumbs.home-aria": "Home",
      "router.breadcrumbs.nav-aria-label": "navigazione briciole di pane",
      "search.advanced-search.filter-add.label": "Aggiungi Filtro",
      "search.advanced-search.filter-add.select-placeholder": "Aggiungi Filtro",
      "search.component.advanced-search-field.date.placeholder-fallback": "GG/MM/AAAA",
      "search.component.search-actions.reset-button.text": "Rimuovi filtri",
      "search.component.search-actions.save-filter-button.arial-label": "Salva Selezione Filtri",
      "search.component.search-actions.save-filter-button.tooltips": "Salva Selezione Filtri",
      "search.component.search-actions.submit-button.pristine-message": "Nessun filtro selezionato",
      "search.component.search-actions.submit-button.text": "Cerca",
      "search.component.search-row.remove-filter-button.aria-label": "Rimuovi Filtro",
      "search.component.search-row.remove-filter-button.tooltips": "Rimuovi Filtro",
      "skip-links.open-menu": "Apri il menu di navigazione Skip Link",
      "table.copyable-id.copied": "ID: {{id}} copiato!",
      "table.copyable-id.copy": "Copia ID: {{id}}",
      "table.copyable-id.no-id": "ID non presente!",
      "table.filter-dropdown-search.reset": "Reset",
      "table.filter-dropdown-search.search": "Cerca",
      "table.table-column-filter-buttons.reset": "Reset",
      "table.table-column-filter-buttons.search": "Cerca",
      "table.table-column-filter.date-range-from-placeholder": "Da: DD/MM/YYYY",
      "table.table-column-filter.date-range-to-placeholder": "A: DD/MM/YYYY",
      "table.table-column-filter.text-placeholder": "Cerca",
      "table.table-data-filter-panel.reset": "Pulisci",
      "table.table-data-filter-panel.search": "Cerca",
      "table.table-date-from.from": "Dal",
      "ui.ellipsis.collapse": "contrai",
      "ui.ellipsis.expand": "espandi",
      "use-pagination-a11y.a-pagina": "a pagina",
      "use-pagination-a11y.button.pagina-corrente": "Pagina {{page}}, pagina corrente",
      "use-pagination-a11y.button.vai-alla-pagina": "Vai alla pagina {{page}}",
      "use-pagination-a11y.current-page-sr-message": "Pagina corrente {{page}}.",
      "use-pagination-a11y.current-page-sr-message-total": "Pagina corrente {{page}} di {{total}}.",
      "use-pagination-a11y.dimensioni-della-pagina": "Dimensioni della pagina. {{size}} elementi a pagina selezionato.",
      "use-pagination-a11y.navigazione-pagine-pagina-corrente": "Navigazione pagine. Pagina corrente: {{current}}.",
      "use-pagination-a11y.pagina": "pagina",
      "use-pagination-a11y.total-info-sr": "Da {{start}} a {{end}} di {{total}} elementi totali.",
      "use-pagination-a11y.total-info.di": "di",
      "carenza": "Carenza",
      "eccedenza": "Eccedenza",
      "error-submit-vote-widget.errore-invio-voto": "Si è verificato un errore durante l'invio del voto. Riprovare.",
      "error-submit-vote-widget.id-richiesta-mancante": "Impossibile inviare il voto: ID della richiesta non disponibile",
      "footer.address": "<0>Via del Collegio Romano, 27</0><1>00186 Roma</1><2>Centralino: (+39) 06.6723.1</2>",
      "footer.address-title": "Sede centrale MiC",
      "footer.policy.accessibility-declaration-text": "Dichiarazione di accessibilità",
      "footer.policy.privacy-cookie-policy-text": "Privacy e cookie policy",
      "footer.static-text": "MiC - Direzione Generale Risorse Umane e Organizzazione",
      "footer.transparent-administration-label": "Amministrazione Trasparente",
      "front-footer-numero-verde.alt": "Numero Verde Gratuito 800 991199 Amministrazione Trasparente | Ministero della Cultura",
      "logo.front-name.servizi-online": "Servizi",
      "mic.front-footer-logo.alt": "Logo Ministero della Cultura",
      "mic.logo-nextgenerationeu.alt": "Logo Finanziato dall'unione Europea - NextGenerationEU",
      "multi-preference-widget.add": "Aggiungi",
      "multi-preference-widget.drag-to-sort": "Trascina per ordinare",
      "multi-preference-widget.remove-row": "Rimuovi",
      "siap-data-columns-carenza-eccedenza": "Carenza/Eccedenza",
      "siap-data-columns-organico-di-diritto": "Organico di Diritto",
      "siap-data-columns.organico-di-fatto": "Organico di Fatto",
      "siap-data-columns.profile": "Profilo",
      "siap-data-table.codice-aoo": "Codice AOO",
      "siap-data-table.data-riferimento": "Data di Riferimento",
      "siap-data-table.istituto": "Istituto",
      "siap-data-table.regione": "Regione",
      "siap-data-widget.error-message": "Errore durante il caricamento dei dati",
      "siap-data-widget.error-message-description": "Si è verificato un errore durante il caricamente dei dati da SIAP. Riprovare più tardi.",
      "success-submit-vote-widget.torna-alle-istanze": "Torna alle Domande",
      "success-submit-vote-widget.voto-inviato": "Voto inviato con successo",
      "user.front-login.cie-link.info": "Maggiori informazioni su CIE",
      "user.front-login.cie-link.info-url": "https://www.cartaidentita.interno.gov.it",
      "user.front-login.cns-link.info": "Maggiori informazioni su CNS",
      "user.front-login.cns-link.info-url": "https://www.agid.gov.it/it/piattaforme/carta-nazionale-servizi",
      "user.front-login.page-title.h1.login-page": "Pagina di Login.",
      "user.front-login.spid-link.info": "Maggiori informazioni su SPID",
      "user.front-login.spid-link.info-url": "https://www.spid.gov.it",
      "user.front-login.spid-professionale-link.info": "Maggiori informazioni",
      "user.front-login.spid-professionale-link.info-url": "https://www.spid.gov.it/aziende/",
      "user.front-login.text.cie": "CIE è la Carta di Identità Elettronica che, oltre ad attestare l’identità del cittadino, permette l’accesso ai servizi digitali della Pubblica Amministrazione.",
      "user.front-login.text.cns": "La CNS è un dispositivo dotato di certificato digitale per accedere ai servizi online della PA. Per l’utilizzo è necessario installare i driver forniti dall’emittente.",
      "user.front-login.text.spid": "SPID è il sistema di accesso che consente di utilizzare, con un’identità digitale unica, i servizi online della Pubblica Amministrazione e dei privati accreditati.",
      "user.front-login.text.spid-professionale": "Lo SPID Professionale consente a imprese e professionisti di accedere ai servizi online della PA qualificandosi come rappresentanti di una persona giuridica.",
      "user.front-login.title-accesso-dipendenti": "Accesso dipendenti",
      "user.front-login.title-spid-professionale": "SPID Professionale",
      "user.front-login.title-utenti-italiani": "Utenti italiani",
      "user.login.employee": "Login Dipendenti",
      "user.login.employee-password": "Password",
      "user.login.employee-title": "Effettua l’accesso dipendenti",
      "user.login.employee-username": "Nome utente",
      "user.login.login-button": "Accedi",
      "user.login.login-button-employee-access-divider": "ACCESSO DIPENDENTI",
      "user.login.login-button-or-divider": "OPPURE",
      "user.login.pa-users.description": "Accesso riservato al personale del Ministero della Cultura.",
      "user.login.pa-users.link.back": "Indietro",
      "user.login.pa-users.pa-button.utenti-pa": "Utenti PA",
      "user.login.title": "Effettua l’accesso",
      "widgets.candidate.change-button-text": "Cambia",
      "widgets.candidate.members-load-error": "Errore durante il caricamento dei membri della lista elettorale",
      "widgets.candidate.modal-select-member-title": "Seleziona Membro",
      "widgets.candidate.select-button-text": "Scegli",
      "widgets.electoral-list-chooser.members-load-error": "Errore durante il caricamento dei membri della lista elettorale",
      "widgets.electoral-list-chooser.no-candidates": "Nessun candidato disponibile",
      "burden-payment-state-tag.attesa-pagamento": "Attesa Pagamento",
      "burden-payment-state-tag.da-pagare": "Da Pagare",
      "burden-payment-state-tag.pagato": "Pagato",
      "burden-payment-state-tag.pagato-parzialmente": "Pagato Parzialmente",
      "burden-selection-table.seleziona-onere": "Seleziona onere ",
      "burden-selection-table.seleziona-oneri": "Seleziona tutti gli oneri",
      "burden-table.crea-pagamento": "Crea Pagamento",
      "burden-table.totale-selezionato": "Totale selezionato",
      "burdens-columns.da-pagare-dopo-invio": "Da pagare dopo l'invio",
      "burdens-columns.descrizione": "Descrizione",
      "burdens-columns.facoltativo": "Facoltativo",
      "burdens-columns.importo": "Importo",
      "burdens-columns.obbligatorio": "Obbligatorio",
      "burdens-columns.stato-onere": "Stato Onere",
      "burdens-columns.tipo": "Tipo",
      "download-receipt.errore-in-download": "Si è verificato un problema durante il download del file",
      "error-submit-module-form.error-saving": "Errore durante il salvataggio",
      "error-submit-module-form.errore-salvataggio-modulo": "Errore durante il salvataggio, ID Modulo non presente",
      "error-submit-module-form.errore-salvataggio-richiesta": "Errore durante il salvataggio, ID Richiesta non presente",
      "fillable-form.sezione.sr-only-anchor": "Sezione: {{sectionName}}",
      "form.applicazione-marca-da-bollo": "Applicando la marca da bollo, la richiesta verrà congelata e non sarà possibile applicare modifiche.",
      "form.avanti": "Avanti",
      "form.back-to-inquiries": "Annulla",
      "form.button.paga-il-bollo": "Paga il Bollo",
      "form.conferma": "Conferma",
      "form.conferma-di-procedere": "Confermi di voler procedere?",
      "form.elenco-pagamenti": "Elenco Pagamenti",
      "form.errore-in-download": "Si è verificato un problema durante il download del file",
      "form.non-ci-sono-modifiche": "Non ci sono modifiche da salvare",
      "form.oneri-della-domanda": "Oneri della Domanda",
      "form.procedi-al-pagamento": "Procedi al pagamento online",
      "form.procedi-al-pagamento-bollo": "Procedi al pagamento del Bollo",
      "form.procedi-al-pagamento-link-esterno": "Procedi al pagamento (apre un link esterno)",
      "form.salva": "Salva",
      "form.salva-modulo-download-pdf": "Salva il modulo per scaricare il documento PDF",
      "form.scarica-avviso": "Scarica Avviso",
      "form.scarica-ricevuta": "Scarica Ricevuta",
      "form.seleziona-gli-oneri": "Seleziona gli oneri per procedere al pagamento",
      "menu-items.pagamenti": "Pagamenti",
      "menu-items.riepilogo-e-invio": "Riepilogo e Invio",
      "module-form.avviso-rimozione-moduli": "Attenzione, una volta rimossi, i dati compilati dei moduli andranno perduti. Se riattivati in seguito, sarà necessario ricompilare i moduli.",
      "module-form.confermare-le-modifiche-ai-moduli": "Confermare le modifiche ai moduli?",
      "module-form.moduli-da-compilare-in-aggiunta": "Saranno aggiunti {{length}} nuovi moduli da compilare:",
      "module-form.rimozione-del-modulo-corrente": "Sarà rimosso il seguente modulo:",
      "module-form.rimozione-moduli": "Saranno rimossi {{length}} moduli:",
      "module-form.salvando-le-richieste-verranno-apportate-le-modifiche": "Salvando la richiesta verranno apportate le seguenti modifiche:",
      "module-form.un-modulo-da-compilare-in-aggiunta": "Verrà aggiunto il seguente modulo da compilare:",
      "module-title.altro-modulo": "Altro Modulo",
      "module-tooltip-text.completato": "Completato",
      "module-tooltip-text.in-attesa-della-firma": "In attesa della firma",
      "module-tooltip-text.in-fase-di-compilazione": "In fase di compilazione",
      "module-tooltip-text.modulo-non-valido": "Modulo non valido",
      "module-validation-state-text.compila": "Compila",
      "module-validation-state-text.completato": "Completato",
      "module-validation-state-text.firma": "Firma",
      "module.state-progress-bar.stato-del-modulo": "Stato del Modulo",
      "payment-burden-type-tag.bollo": "",
      "payment-burden-type-tag.modello-1": "",
      "payment-burden-type-tag.modello-3": "",
      "payment-burden-type-tag.oneri": "",
      "payment-columns.codice": "Codice",
      "payment-columns.importo": "Importo",
      "payment-columns.stato-pagamento": "Stato Pagamento",
      "payment-state-tag.completato": "COMPLETATO",
      "payment-state-tag.da-pagare": "DA PAGARE",
      "payment-state-tag.errore-pagamento": "ERRORE PAGAMENTO",
      "payment-state-tag.pendente": "PENDENTE",
      "payment-table.azioni": "Azioni",
      "payment-table.tipi": "Tipo",
      "quote-columns.data": "Data",
      "quote-columns.descrizione": "Descrizione",
      "quote-columns.imponibile": "Imponibile",
      "quote-columns.importo": "Importo",
      "quote-columns.iva": "IVA",
      "quote-columns.numero": "Numero",
      "quote-columns.stato": "Stato",
      "quote-state-tag.attesa-approvazione": "Attesa Approvazione",
      "quote-state-tag.attesa-pagamento": "Attesa Pagamento",
      "quote-state-tag.pagato": "Pagato",
      "quote-state-tag.rifiutato": "Rifiutato",
      "quote-table.azioni": "Azioni",
      "quote-table.azioni.button-confirm.accept.message.accetta-preventivo-prima-riga": "Confermi di aver scaricato e letto il il preventivo nella sua interezza.",
      "quote-table.azioni.button-confirm.accept.message.accetta-preventivo-seconda-riga": "Confermi di voler accettare il preventivo?",
      "quote-table.azioni.button-confirm.accept.text": "ACCETTA",
      "quote-table.azioni.button-confirm.refuse.message.rifiuto-preventivo": "Sei sicuro di voler rifiutare il Preventivo?",
      "quote-table.azioni.button-confirm.refuse.text": "RIFIUTA",
      "quote-table.azioni.button.aria-label.scarica-preventivo": "Scarica Preventivo",
      "quote-table.azioni.button.tooltips.scarica-preventivo": "Scarica Preventivo",
      "quote-table.errore-in-accettazione-preventivo": "Si è verificato un problema durante l'accettazione del preventivo",
      "quote-table.errore-in-download-file": "Si è verificato un problema durante il download del file",
      "stamp-duty-payment.avvio-pagamento": "Avvio del pagamento...",
      "stamp-duty-payment.errore-avvio-pagamento": "Si è verificato un errore durante l'avvio del pagamento",
      "stamp-duty-payment.errore-modifica-stato-pagamento": "Si è verificato un errore durante la modifica dello stato del pagamento",
      "start-payment-button.avvio-pagamento": "Avvio del pagamento...",
      "start-payment-button.errore-avvio-pagamento": "Si è verificato un errore durante l'avvio del pagamento",
      "submission-confirm-update.conferma-aggiornamento-modulo": "Confermi di voler aggiornare il modulo?",
      "submission-confirm-update.conferma-modifiche": "Conferma modifiche attivazioni moduli",
      "submission-consolidated-pdf-button.errore-in-download": "Si è verificato un problema durante il download del file",
      "submission-consolidated-pdf-button.scarica-pdf-richiesta": "Scarica PDF Richiesta",
      "submission-consolidated-pdf-button.visualizza-pdf-richiesta": "Visualizza PDF Richiesta",
      "submission-list.unknown-applicant": "non identificato",
      "submission-menu-item.bolli": "Bolli",
      "submission-menu-item.oneri": "Oneri",
      "submission-menu-item.pagamenti": "Pagamenti",
      "submission-menu-item.preventivi": "Preventivi",
      "submission-menu-item.scheda-domanda": "Scheda Domanda",
      "submission-menu-item.sezione-disabilitata": "Sezione disabilitata",
      "submission-menu-items.altro-modulo": "Altro Modulo",
      "submission-menu-items.modulo-principale": "Modulo Principale",
      "submission-menu-items.sezione": "Sezione {{index}}",
      "submission-menu-label.aria-label.name-prefix": "sezione",
      "submission-menu.navigazione-richiesta": "Navigazione della richiesta",
      "submission-menu.section.dirty-badge.dirty.sezione-da-salvare": "Sezione da salvare",
      "submission-menu.section.dirty-badge.error.sezione-non-valida": "Sezione non valida",
      "submission-menu.selezionato": "selezionato",
      "submission-module-button.errore-in-download": "Si è verificato un problema durante il download del file",
      "submission-module-button.richiesta-non-pubblica": "Impossibile scaricare il PDF con Omissis: la Richiesta non è pubblica",
      "submission-module-button.scarica-pdf": "Scarica PDF",
      "submission-module-button.scarica-pdf-firmato": "Scarica PDF",
      "submission-module-button.scarica-pdf-omissis": "Scarica PDF Omissis",
      "submission-module-button.visualizza-pdf": "Visualizza PDF",
      "submission-module-button.visualizza-pdf-omissis": "Visualizza PDF Omissis",
      "submission-payment-form.errore-richiesta": "Si è verificato un errore durante il caricamento della richiesta. La richiesta non è definita.",
      "submission-payment-form.errore-richiesta-titolo": "Richiesta non definita",
      "submission-payment-form.oneri-bolli-da-pagare-dopo-invio": "Di seguito trovi i pagamenti da effettuare a seguito dell’invio",
      "submission-payment-form.pagamento-annullato": "Pagamento annullato",
      "submission-payment-form.pagamento-completato": "Il pagamento è stato completato con successo",
      "submission-payment-form.pagamento-completato-con-successo": "Pagamento completato con successo",
      "submission-payment-form.pagamento-errore": "Si è verificato un errore durante il pagamento",
      "submission-payment-form.seleziona-bolli": "Seleziona i bolli per procedere al pagamento",
      "submission-payment-form.seleziona-oneri": "Seleziona gli oneri per procedere al pagamento",
      "submission-state-tag.bozza": "BOZZA",
      "submission-state-tag.cancellata": "CANCELLATA",
      "submission-state-tag.conclusa": "CONCLUSA",
      "submission-state-tag.creata": "CREATA",
      "submission-state-tag.in-invio": "IN INVIO",
      "submission-state-tag.integrata": "INTEGRATA",
      "submission-state-tag.integrata-dopo-richiesta-integrazione": "Integrata dopo richiesta di integrazione",
      "submission-state-tag.inviata": "INVIATA",
      "submission-state-tag.pagamento": "IN PAGAMENTO",
      "submission-state-tag.ricevuta": "RICEVUTA",
      "submission-state-tag.richiesta-accettazione-preventivo": "È richiesta l'accettazione del Preventivo",
      "submission-state-tag.richiesta-integrazione": "L’istanza è stata abilitata alla presentazione di modifiche e/o integrazioni",
      "submission-state-tag.richiesta-pagamento-preventivo": "È richiesto il pagamento del Preventivo",
      "submission-state-tag.sono-presenti-preventivi": "Sono presenti preventivi",
      "submission.richiesta": "Richiesta",
      "alert-message.error.close-icon-label": "Chiudi",
      "form.alert-message.content": "Sono presenti errori di compilazione ({{errors_count}})",
      "form.error-list.hide": "Nascondi {{errorCount}} errori",
      "form.error-list.hide_one": "Nascondi 1 errore",
      "form.error-list.show-more": "Mostra altri {{errorCount}} errori",
      "form.error-list.show-more_one": "Mostra 1 altro errore",
      "form.prevent-navigation.prompt": "Sei sicuro di voler abbandonare la pagina? Tutte le modifiche non salvate andranno perse",
      "form.submit-button.save": "Salva",
      "form.submit-button.tooltip-not-dirty": "Non ci sono modifiche da salvare",
      "inputs.async-select-input-meta.content": "Mostrati {{shown}} di {{total}}.",
      "inputs.async-select-input-meta.filter": "Filtrare la ricerca digitando per migliorare i risultati.",
      "inputs.async-select.caricamento-opzioni": "Caricamento...",
      "inputs.async-select.errore-caricamento-opzioni": "Errore durante il caricamento dei dati",
      "inputs.async-select.nessun-risultato": "Nessun risultato trovato",
      "inputs.color.select": "Seleziona Colore",
      "inputs.date-input.clear-button": "Pulisci il campo",
      "inputs.date-input.error": "La data inserita non è valida",
      "inputs.dragger-input-body.title": "Fare clic o trascinare il file in quest’area per caricarlo",
      "inputs.dragger-input.info": "Formati consentiti: {{formats}}",
      "inputs.dragger-input.title": "Fare click o trascinare il file in quest’area per caricarlo",
      "inputs.file-extension-select-input.placeholder": "Scrivi e premi invio per aggiungere un nuovo formato",
      "inputs.info-icon-row": "Fai click sull’icona {{content}} di anteprima",
      "inputs.rich-text-link-button.label": "URL",
      "inputs.rich-text-link-button.placeholder": "Inserisci l'URL del link",
      "inputs.rich-text-menu-bar.align-center": "Allinea al centro",
      "inputs.rich-text-menu-bar.align-left": "Allinea a sinistra",
      "inputs.rich-text-menu-bar.align-right": "Allinea a destra",
      "inputs.rich-text-menu-bar.bold": "Grassetto",
      "inputs.rich-text-menu-bar.color": "Colore",
      "inputs.rich-text-menu-bar.hard-break": "Accapo",
      "inputs.rich-text-menu-bar.italic": "Corsivo",
      "inputs.rich-text-menu-bar.justify-text": "Giustifica testo",
      "inputs.rich-text-menu-bar.ordered-list": "Elenco ordinato",
      "inputs.rich-text-menu-bar.strikethrough": "Barrato",
      "inputs.rich-text-menu-bar.title": "Titolo",
      "inputs.rich-text-menu-bar.underline": "Sottolineato",
      "inputs.rich-text-menu-bar.unordered-list": "Elenco",
      "inputs.select.multipla": "(Permette selezioni multiple)",
      "inputs.select.nessuna-opzione-disponibile": "(Nessuna opzione disponibile)",
      "inputs.upload-input.title": "Carica file",
      "utils.decorate-with-form.submit": "Invia",
      "async-value-widget.error-message": "Si è verificato un errore, riprova più tardi",
      "divider-widget.new-divider-title": "Nuovo titolo divisore",
      "info-widget.collapse": "Contrai",
      "info-widget.expand": "Espandi",
      "info-widget.new-info-message": "Nuovo messaggio informativo",
      "inputs.rich-text-advanced-link-node.screen-reader-content": "(Si apre in una nuova finestra)",
      "paragraph-widget.new-paragraph": "Nuovo paragrafo",
      "payment-row-widget.base-unit-amount": "Importo Listino",
      "payment-row-widget.description": "Descrizione",
      "payment-row-widget.discount": "Sconto/Esenzione",
      "payment-row-widget.quantity": "Quantità",
      "payment-row-widget.taxable-amount": "Imponibile",
      "payment-row-widget.title": "Includi nel pagamento",
      "payment-row-widget.total": "Totale",
      "payment-row-widget.unit": "Unità di Misura",
      "payment-row-widget.unit-amount": "Importo Unitario",
      "payment-row-widget.vat": "IVA",
      "payment-row-widget.vat-amount": "IVA",
      "rules.confirm-widget-required.error": "È necessario confermare i dati mostrati oppure modificarli.",
      "rules.date-range.max-date": "La data deve essere precedente al {{to_date}}",
      "rules.date-range.min-date": "La data deve essere successiva al {{from_date}}",
      "rules.item-range.min": "Il campo ${label} deve contenere almeno {{min}} elementi",
      "rules.text-format.number": "Il campo ${label} non è un numero.",
      "rules.text-format.phone": "Il campo ${label} non è un numero di telefono.",
      "rules.unique-field-rule.error": "Il campo {{label}} deve essere univoco",
      "rules.value-range.max": "Il campo ${label} deve essere minore o uguale a {{max}}",
      "rules.value-range.min": "Il campo ${label} deve essere maggiore o uguale a {{min}}",
      "subsection.drawer.button.back": "Indietro",
      "ui.info-icon.content": "Testo informativo aggiuntivo",
      "widget.async-table-widget-error-description": "Impossibile visualizzare la tabella. Si è verificato un errore durante il caricamento dei dati. Riprovare",
      "widget.async-table-widget-error-title": "Errore durante il caricamento della tabella \"{{widgetCode}}\"",
      "widgets.add-row-buttton.add": "Aggiungi",
      "widgets.add-row-buttton.max-options-reached": "Numero massimo di opzioni raggiunte",
      "widgets.async-select-widget-component.not-found": "Nessun elemento trovato.",
      "widgets.async-select-widget-component.service-not-responding": "Impossibile recuperare i dati dal servizio {{service}}. Riprovare più tardi.",
      "widgets.async-select-widget-component.type-to-search": "Digita per iniziare a cercare",
      "widgets.async-select.select-text": "Scegli",
      "widgets.confirm-widget-layout-component.cancel": "Annulla Modifiche",
      "widgets.confirm-widget-layout-component.confirm": "Confermato",
      "widgets.confirm-widget-layout-component.edit": "Modifica",
      "widgets.multi-select-select-component.placeholder": "Placeholder",
      "widgets.remove-row-buttton.min-options-reached": "Numero minimo di opzioni raggiunto",
      "widgets.repeatable-content.alert-sr.added": "Elemento {{index}} aggiunto alla lista {{labelText}}.",
      "widgets.repeatable-content.alert-sr.removed": "Elemento {{index}} rimosso dalla lista {{labelText}}. Gli elementi successivi sono stati riordinati.",
      "widgets.select-widget.select-text": "Scegli",
      "widgets.subsection-drawer-component.expand-aria": "Espandi",
      "widgets.subsection-drawer-component.open": "Apri",
      "widgets.use-exec-async-service-action.error-during-loading": "Si è verificato un errore durante l'esecuzione del servizio asincrono",
      "widgets.use-exec-async-service-action.no-handle-function": "Attesa caricamento del servizio asincrono. Riprovare.",
      "widgets.use-repeat-controller-confirm-modal.cancel": "Annulla",
      "widgets.use-repeat-controller-confirm-modal.content": "Riducendo il numero di elementi, rimuoverai le righe in eccesso dalla lista. Continuare?",
      "widgets.use-repeat-controller-confirm-modal.continue": "Continua",
      "widgets.use-repeat-controller-confirm-modal.title": "Rimuovere elementi dalla lista?",
      "ai-file-check-message.tooltip.suggestions": "Puoi comunque procedere oppure ricaricare il documento.",
      "ai-file-check-message.warning.not-identification": "Il tipo documento non sembra corretto.",
      "ai-module-check-message.success.digitally-signed": "Modulo firmato digitalmente.",
      "ai-module-check-message.warning.not-signatures": "Il modulo non sembra firmato correttamente.",
      "ai-module-check-message.warning.not-similatity": "Il modulo caricato sembra differente da quello scaricato.",
      "ai-module-check-message.warning.suggestions": "Per ricaricare il modulo, ritorna in compilazione.",
      "button-icon-toggle-read.mark-as-read": "Segna come letto",
      "button-icon-toggle-read.read": "letto",
      "button-icon-toggle-read.read-on": "Letto il",
      "button-icon-toggle-read.unread": "non letto",
      "cmmunication-state-tag.default": "N/A",
      "cmmunication-state-tag.error": "Invio Fallito",
      "cmmunication-state-tag.processing": "In Lavorazione",
      "cmmunication-state-tag.success": "Inviata",
      "common.communication-search-form.extended-search": "Ricerca Estesa",
      "common.communication-search-form.remove-filters": "Rimuovi Filtri",
      "common.communication-search-form.search": "Cerca",
      "common.communication-search-form.search-button": "Cerca",
      "common.communication-search-form.search-placeholder": "Cerca...",
      "common.communication-search-form.subject": "Oggetto Comunicazione",
      "communication-attachment-group-editor.must-save-communication": "È necessario salvare la comunicazione",
      "communication-attachment-group-editor.upload-file": "Carica file {{maxCount}}",
      "communication-attachments.attachments": "Allegati",
      "communication-attachments.title": "Allegati",
      "communication-button.new-comm": "Nuova Comunicazione",
      "communication-button.send-comm": "Invio Comunicazione",
      "communication-details.receiver": "Destinatari",
      "communication-details.sender": "Mittente",
      "communication-extend-search-form.communication-type": "Tipo Comunicazione",
      "communication-extend-search-form.message": "Messaggio",
      "communication-extend-search-form.search-in-message": "Cerca nel messaggio...",
      "communication-extend-search-form.send-date": "Data di Invio",
      "communication-extend-search-form.sent-after": "Inviata dopo il",
      "communication-extend-search-form.sent-before": "Inviata prima del",
      "communication-extend-search-form.so": "Ordinamento",
      "communication-extend-search-form.sort-by": "Ordina per...",
      "communication-extend-search-form.subject": "Oggetto",
      "communication-extend-search-form.write-or-select-date": "Scrivi o seleziona la data...",
      "communication-header.receivers": "Destinatari",
      "communication-header.sender": "Mittente",
      "communication-item.edit": "Modifica",
      "communication-item.edit-and-send": "Modifica e Invia",
      "communication-item.reply": "Rispondi",
      "communication-list.no-comms-to-show": "Non ci sono comunicazioni da mostrare",
      "communication-recipient.protocol-number": "Protocollo",
      "communication-recipient.registration-date": "Data protocollo",
      "communication-recipient.send-date": "Data invio",
      "communication-request-schema.addictional-notes": "Note Addizionali",
      "communication-request-schema.communication-type": "Tipo Comunicazione",
      "communication-request-schema.manually-loaded": "Caricata Manualmente",
      "communication-request-schema.message": "Messaggio",
      "communication-request-schema.protocol-date": "Data Protocollo",
      "communication-request-schema.protocol-number": "Numero Protocollo",
      "communication-request-schema.receiver-office": "Ufficio Destinatario",
      "communication-request-schema.sender-office": "Ufficio Mittente",
      "communication-request-schema.subject": "Oggetto",
      "communication-search-schema.sent-after": "Inviata dopo il",
      "communication-search-schema.sent-before": "Inviata prima del",
      "communication-searchable.search-by-type": "Seleziona il tipo...",
      "communication-tag-option-holder": "TITOLARE",
      "communication-tag-option.applicant": "RICHIEDENTE",
      "communication-tag-option.co-holder": "PARTE INTERESSATA",
      "communication-tag-option.delegate-for-comp": "DELEGATO ALLA COMPILAZIONE",
      "communication-tag-option.delegate-for-sign": "DELEGATO ALLA FIRMA",
      "communication-tag-option.manager": "GESTORE",
      "communication-tag-option.no-type": "N/D",
      "communication-tag-option.other-variable-office": "UFFICIO REFERENTE",
      "communication-tag-option.prosecutor": "PROCURATORE",
      "communication-tag-option.responsible-office": "UFFICIO RICEVENTE",
      "communication-tag-option.third-organization": "ENTE TERZO",
      "communication-type.message": "Messaggio",
      "communication-type.receivers": "Destinatari",
      "communication-type.sender": "Mittente",
      "communication.draft": "BOZZA",
      "communication.sent": "INVIATA",
      "communications-sender-protocol.protocol-date": "Data protocollo",
      "communications-sender-protocol.protocol-number": "Protocollo",
      "communications-sender-protocol.tag.errore": "ERRORE",
      "communications-sender-protocol.tag.processing": "IN LAVORAZIONE",
      "communications-sender-protocol.tooltip-title.error-protocolling": "Errore nella protocollazione della comunicazione",
      "communications-sender-protocol.tooltip-title.processing-protocolling": "Protocollo in lavorazione",
      "communications.additional-notes": "Note addizionali",
      "communications.additional-notes-placeholder": "Note addizionali alla comunicazione",
      "communications.error-in-communication": "Errore nella comunicazione",
      "communications.error-in-sending-communication": "Errore nell'invio della comunicazione",
      "communications.error-protocolling-communication": "Errore nella protocollazione della comunicazione",
      "communications.in-working": "Comunicazione in lavorazione",
      "communications.protocol-date": "Data Protocollo",
      "communications.protocol-number": "Numero Protocollo",
      "communications.select": "Selezione...",
      "communications.select-receiver-subprocedure": "Seleziona endoprocedimento destinatario",
      "communications.subject": "Oggetto",
      "communications.subject-placeholder": "Oggetto della comunicazione",
      "communications.type-label": "Tipo Comunicazione",
      "communications.type-row": "Tipo Comunicazione",
      "communications.type-title": "Tipo di Comunicazione",
      "competence-widget.error-fetching-competences": "Impossibile recuperare i dati delle Competenze. Riprovare più tardi.",
      "competence-widget.info-message": "È stata selezionata automaticamente la Competenza {{competenceName}} in base alle geometrie indicate.",
      "competence-widget.no-element-found": "Nessun elemento trovato.",
      "comunicazioni.tooltip-salva-prima-di-inviare": "Salva la comunicazione prima di inviarla",
      "confirm-update-modal.added-new-module-activation": "È stata aggiunta una nuova attivazione modulo:",
      "confirm-update-modal.added-new-multiple-modules-activation": "Sono state aggiunte {{length}} nuove attivazioni moduli:",
      "confirm-update-modal.changes-will-be-applied-to-inquiries": "Le modifiche saranno apportate a {{inquiriesLength}} domand{{oneOrMore}}:",
      "confirm-update-modal.removed-module-activation": "È stata rimossa una attivazione modulo:",
      "confirm-update-modal.removed-multiple-modules-activation": "Sono state rimosse {{length}} attivazioni moduli:",
      "domanda.copertina.categorie": "Categorie",
      "domanda.copertina.destinatari": "Destinatari",
      "domanda.copertina.scadenza": "Scadenza",
      "download-file-button.error-download-file": "Si è verificato un problema durante il download del file",
      "download-file.error-downloading-file": "Si è verificato un problema durante il download del file",
      "download-file.no-filename-from-header": "Documento",
      "download-widget.error": "Si è verificato un problema durante il download del file. Riprovare.",
      "download-widget.file-not-found": "File non trovato",
      "email-verification-rule.message": "È necessario verificare l'email per proseguire",
      "email-verification-widget.check-mail-box-to-confirm": "Ti è stata inviata una email di verifica alla tua casella di posta. Controlla la tua posta elettronica per confermare la tua email.",
      "email-verification-widget.confirm-reception": "Conferma Ricezione",
      "email-verification-widget.error-in-sending-verification-mail": "Errore durante l'invio dell'email di verifica",
      "email-verification-widget.invalid-email": "L'email inserita non è valida",
      "email-verification-widget.verified": "Verificata",
      "email-verification-widget.verify-email": "Verifica Email",
      "error-while-resetting-notification-flag": "Errore durante il reset del flag di notifica",
      "export--multiple-semantic-field-select.select--multiple-semantic-fields-to-export": "Seleziona i campi semantici multipli da esportare come righe",
      "export--multiple-semantic-field-select.select-multiple-semantic-fields-to-export-title": "Seleziona i campi semantici multipli da esportare. Verrà aggiunta una riga per ogni campo semantico multiplo.",
      "export-field-select.select-fields-to-export": "Seleziona i campi da esportare",
      "export-field-select.select-fields-to-export-title": "Seleziona i campi da esportare. Se non indichi nessun campo, l'esportazione conterrà tutti i dati.",
      "export-file-button.cancel-text": "Annulla",
      "export-file-button.confirm-export": "Stai per esportare i dati trovati dai filtri di ricerca attualmente attivi{{exportAll}}. A seconda dei filtri utilizzati questa operazione potrebbe richiedere diverso tempo. Continuare?",
      "export-file-button.download-page": "Scarica solo una pagina (max. {{pageSize}} {{entity}})",
      "export-file-button.export-procedures": "Esportazione {{typeTitle}} Procedimenti",
      "export-file-button.export-title": "Esporta {{typeTitle}}",
      "export-file-button.ok-text": "Esporta",
      "export-file-button.remember-fields": "Ricorda i campi per la prossima esportazione",
      "export-semantic-order.placeholder": "Aggiungi ordinamento",
      "interazioni.annulla": "Annulla",
      "interazioni.salva": "Salva",
      "map-widget.drawn-geometries": "Geometrie disegnate",
      "map-widget.geometries.point-title": "#{{numero}}",
      "map-widget.intersections": "Intersezioni",
      "map-widget.no-geometries": "Nessuna geometria presente",
      "map-widget.search-address.aria-label": "Cerca indirizzo",
      "map-widget.search-address.load-address-error-mpe-002": "Errore durante il caricamento dell'indirizzo (MPE-002)",
      "map-widget.search-address.no-result-found-no-extent-mpe-0001": "Nessun risultato trovato per l'indirizzo selezionato. (MPE-0001)",
      "map-widget.search-address.not-found-text.loading": "Caricamento...",
      "map-widget.search-address.not-found-text.no-result": "Nessun risultato",
      "map-widget.search-address.not-found-text.write-to-search": "Scrivi per cercare",
      "map-widget.search-address.placeholder": "Cerca indirizzo...",
      "map-widget.title": "Centra mappa sulle geometrie",
      "map-widget.upload-warning-message": "Nessuna geometria presente nel file.",
      "mappa.controlli.cerca-particella.modale.form-button.cerca": "Cerca",
      "mappa.controlli.cerca-particella.modale.form-button.seleziona": "Seleziona",
      "mappa.controlli.cerca-particella.modale.form-label.allegato-catastale": "Allegato catastale",
      "mappa.controlli.cerca-particella.modale.form-label.comune": "Comune",
      "mappa.controlli.cerca-particella.modale.form-label.foglio-catastale": "Foglio catastale",
      "mappa.controlli.cerca-particella.modale.form-label.particella-catastale": "Particella catastale",
      "mappa.controlli.cerca-particella.modale.form-label.sezione-catastale": "Sezione catastale",
      "mappa.controlli.cerca-particella.modale.form-label.sviluppo-catastale": "Sviluppo catastale",
      "mappa.controlli.cerca-particella.modale.form.errore.durante-la-ricerca": "Si è verificato un errore durante la ricerca",
      "mappa.controlli.cerca-particella.modale.form.errore.nessun-risultato": "Nessun risultato trovato",
      "mappa.controlli.cerca-particella.modale.form.errore.nessuna-geometria-valida": "Errore durante la ricerca. Nessuna geometria valida trovata",
      "mappa.controlli.cerca-particella.modale.titolo": "Cerca per particella catastale",
      "mappa.controlli.cerca-particella.pulsante.testo": "Particella",
      "mappa.controlli.disegna": "Disegna",
      "mappa.controlli.elimina": "Elimina",
      "mappa.controlli.visualizza": "Visualizza",
      "mappa.livelli.popover.form-item-label-prefix.visibilita": "Visibilità",
      "mappa.livelli.popover.pulsante-chiudi": "Chiudi",
      "mappa.livelli.popover.titolo.visibilita-dei-livelli": "Visibilità dei Livelli",
      "mappa.livelli.pulsante": "Livelli",
      "notification-drawer.priority-tag.alta": "ALTA",
      "notification-drawer.priority-tag.bassa": "BASSA",
      "notification-drawer.priority-tag.normale": "NORMALE",
      "notification-drawer.priority-tag.priorita": "Priorità:",
      "notification-drawer.priority-tag.urgente": "URGENTE",
      "notification-drawer.title": "Notifiche",
      "notification-filter-switch.all": "Tutte",
      "notification-filter-switch.to-read": "Da Leggere",
      "notification-type-icon.warning": "Attenzione",
      "notification.error": "Si è verificato un errore, riprovare.",
      "notifiche.alt-image-notifica-da-leggere ": "Notifica da leggere",
      "notifiche.alt-image-notifica-letta": "Notifica Letta",
      "notifiche.da-leggere ": "Da leggere",
      "notifiche.letta-il": "Letta il",
      "notifiche.segna-come-letta": "Segna come letta",
      "province-widget-schema.mun-belfiore.code": "Codice Belfiore comune",
      "province-widget-schema.mun-cap": "Cap comune",
      "province-widget-schema.mun-istat": "Codice Istat comune",
      "province-widget-schema.mun-lat": "Latitudine comune",
      "province-widget-schema.mun-lng": "Longitudine comune",
      "province-widget-schema.mun-name": "Nome comune",
      "province-widget-schema.mun-province": "Provincia comune",
      "province-widget-schema.mun-region": "Regione comune",
      "province-widget-schema.prov-belfiore-code": "Codice Belfiore",
      "province-widget-schema.prov-lat": "Latitudine provincia",
      "province-widget-schema.prov-lng": "Longitudine provincia",
      "province-widget-schema.prov-name": "Nome provincia",
      "province-widget-schema.prov-region": "Regione provincia",
      "province-widget.error": "Errore",
      "province-widget.error-description": "Errore durante il caricamento dei dati delle province. Riprovare più tardi.",
      "recipient-type.dipendente": "Dipendente",
      "recipient-type.ente-pubblico": "Ente Pubblico",
      "recipient-type.persona-fisica": "Persona Fisica",
      "recipient-type.persona-giuridica": "Persona Giuridica",
      "semantic-tag-searchable-field.from": "Da",
      "semantic-tag-searchable-field.to": "A",
      "stato.tipo-domanda.annullata": "ANNULLATA",
      "stato.tipo-domanda.aperta": "APERTA",
      "stato.tipo-domanda.bozza": "BOZZA",
      "stato.tipo-domanda.chiusa": "CHIUSA",
      "stato.tipo-domanda.collaudo": "COLLAUDO",
      "stato.tipo-domanda.in-corso": "IN CORSO",
      "stato.tipo-domanda.pronta": "PRONTA",
      "stato.tipo-domanda.pubblicata": "PUBBLICATA",
      "stato.tipo-domanda.sola-lettura": "SOLA LETTURA",
      "stato.tipo-domanda.sospesa": "SOSPESA",
      "triggerable-modules-confirm-update.generic-error": "Si è verificato un errore generico, riprovare più tardi",
      "upload-widget.file-must-be-uploaded": "Il file ${label} deve essere caricato",
      "upload-widget.filelist.download-file": "Scarica File",
      "upload-widget.public-doc": "Documento pubblico",
      "uploaded-file-row.button-delete-confirm.button-aria-label": "Elimina file",
      "uploaded-file-row.button-delete-confirm.title": "Sei sicuro di voler rimuovere il file?",
      "widget-immagine.anteprima": "Anteprima Immagine",
      "widget-immagine.chiudi": "Chiudi",
      "widget-immagine.scarica": "Scarica Immagine",
      "user.auto-login.response.error.sub-title": "Non è stato possibile completare la procedura di login.",
      "user.auto-login.response.error.title": "Errore durante il login",
      "user.auto-login.response.success.submit-button": "Torna al Login",
      "user.login.cie-button": "Entra con CIE",
      "user.login.cns-button": "Entra con CNS",
      "user.login.cns-error": "Si e' verificato un errore durante l'accesso tramite CNS. Non è stato possibile recuperare un certificato valido per l'accesso. Verificare i requisiti per l’accesso CNS e riprovare. (CNS002)",
      "user.login.cns-technical-error": "Si è verificato un errore tecnico durante il login (CNS001).",
      "user.login.eidas-button": "Login with eIDAS",
      "user.login.spid-button": "Entra con SPID",
      "user.login.spid-link.dont-have-spid": "Non hai SPID?",
      "user.login.spid-link.dont-have-spid-url": "https://www.spid.gov.it/richiedi-spid",
      "user.login.spid-link.info": "Maggiori informazioni",
      "user.login.spid-link.info-url": "https://www.spid.gov.it",
      "user.login.spid-link.need-help": "Serve aiuto?",
      "user.login.spid-link.need-help-url": "https://www.spid.gov.it/serve-aiuto",
      "user.login.spid-popover.text-part-a": "SPID è il sistema di accesso che consente di utilizzare, con un’identità digitale unica, i servizi online della Pubblica Amministrazione, sia centrale, sia locale, e dei privati accreditati.",
      "user.login.spid-popover.text-part-b": "Se sei già in possesso di un’identità digitale, accedi con le credenziali del tuo gestore. Se non hai ancora un’identità digitale, richiedila utilizzando il link a seguire:",
      "user.login.spid-popover.title": "Accesso con utenza SPID",
      "user.login.spid-professional-button": "Entra con SPID Professionale",
      "user.login.external-user-email": "Email",
      "user.login.external-user-password": "Password",
      "user.login.password-forgot-link": "Reimposta password.",
      "user.login.password-forgot-question": "Hai dimenticato la password?",
      "user.login.sign-in-link": "Vai al modulo di registrazione.",
      "user.login.sign-in-question": "Non sei ancora registrato sul portale?"
    }
  },
  "en": {
    "translation": {
      "actor-permission-icon.permesso-firmare-modulo": "{{canSign}} sign the form.",
      "actor-permission-icons.can": "You can",
      "actor-permission-icons.cannot": "You cannot",
      "actor-permission-icons.permesso-compilare-modulo": "{{canCompile}} compilare il modulo.",
      "actor-permission-icons.permesso-visualizzazione-modulo": "{{canView}} view the form.",
      "actor-role-tag.tipo-utente-delegato": "You are {{tagOption}} of the Request.",
      "addess-book.delete-row.confirm-title": "Remove the entry from the contacs?",
      "addess-book.form.apply": "Apply",
      "addess-book.form.cancel": "Cancel",
      "addess-book.search": "Search",
      "addres-book.create.success": "New contact successfully created",
      "address-book.already-selected": "Selected",
      "address-book.azioni": "Actions",
      "address-book.button.apri-rubrica": "Open contacts",
      "address-book.columns.codice-fiscale": "Fiscal Code",
      "address-book.columns.cognome": "Surname",
      "address-book.columns.email": "E-mail",
      "address-book.columns.identificativo": "Identifier",
      "address-book.columns.indirizzo": "Address",
      "address-book.columns.nome": "Name",
      "address-book.columns.nome-completo": "Name",
      "address-book.columns.note": "Notes",
      "address-book.create.button-label": "New contact",
      "address-book.drawer.title": "Contact Edit",
      "address-book.edit-button.aria-label": "Go to Edit",
      "address-book.edit-button.tooltip": "Edit",
      "address-book.edit-create.error": "Error while saving",
      "address-book.edit.success": "Contact successfully modified",
      "address-book.edit.user-origin": "User Origin",
      "address-book.filter-schema.label.ricerca-per-altri-campi": "Search by other fields",
      "address-book.filter-schema.label.ricerca-per-cf": "Search by Fiscal Code/E-Mail",
      "address-book.filtered.message": "Personal data found with the selected filters",
      "address-book.input.fiscal-code.aria-label": "Search Fiscal Code/Email",
      "address-book.input.fiscal-code.placeholder": "Fiscal Code/Email",
      "address-book.input.name.aria-label": "Search by other fields",
      "address-book.input.name.placeholder": "Name/surname...",
      "address-book.modal.empty-list.description1.nessun-delegato-vai-alla": "No delegates found, go to the",
      "address-book.modal.empty-list.description2.link.rubrica": "Contacts",
      "address-book.modal.empty-list.description3.per-aggiungerne-di-nuovi": "to add new ones.",
      "address-book.modal.empty-list.message.rubrica-vuota": "Empty Contacts",
      "address-book.modal.error.errore-caricamento-rubrica": "An error occurred while loading Contacts",
      "address-book.modal.title.seleziona-delegato": "Select delegate",
      "address-book.page.breadcrumb.gestione-deleghe": "Delegation",
      "address-book.page.breadcrumb.richieste": "Requests",
      "address-book.page.breadcrumb.rubrica": "Contacts",
      "address-book.page.error.impossibile-caricare-la-rubrica": "Cannot load contacts",
      "address-book.remove-filter-button.label": "Remove filters",
      "address-book.remove.error": "Error while deleting",
      "address-book.remove.success": "Entry successfully removed",
      "address-book.searchable-fields.identificativo-label": "Identifier",
      "address-book.searchable-fields.identificativo-placeholder": "Fiscal Code/E-Mail...",
      "address-book.searchable-fields.ricerca-altri-campi-label": "Search by other fields",
      "address-book.searchable-fields.ricerca-altri-campi-placeholder": "Name, Surname, Address...",
      "address-book.select": "Select",
      "address-book.title": "Contacts",
      "address-book.torna-alle-deleghe": "Back to delegations",
      "annulla-modifiche": "Cancel changes",
      "archive-data.autore": "Author:",
      "archive-data.codice-invio": "Submission Code:",
      "archive-data.data-invio": "Submission Date:",
      "archive-data.numero-fascicolo": "File Number:",
      "archive-data.numero-protocollo": "Protocol Number:",
      "archive-data.oggetto": "Subject:",
      "archive-data.stato": "Status:",
      "archive-details.fascicolo": "File",
      "archive-details.ricevuta-invio": "Submission Receipt",
      "archived-submission.impossibile-caricare-dettaglio-richiesta": "Unable to load details of the archived request.",
      "archived-submission.lists-istanze-trovate-in-base-ai-filtri": "Archived requests found based on the search filters.",
      "archived-submissions.back-to-requests": "My Requests",
      "archived-submissions.columns.see-details-text": "Open the request detail page",
      "archived-submissions.columns.see-details-tooltip": "View request",
      "archived-submissions.columns.subject": "Subject",
      "archived-submissions.impossibile-caricare-elenco-richieste": "Unable to load the list of archived requests",
      "archived-submissions.list-archived-title": "Archived Requests List",
      "archived-submissions.protocol-signature": "Protocol Number",
      "archived-submissions.search.data-invio-al": "To",
      "archived-submissions.search.data-invio-dal": "From",
      "archived-submissions.search.protocol": "Protocol Number",
      "archived-submissions.search.sentDate": "Submission Date",
      "archived-submissions.search.subject": "Subject",
      "archived-submissions.sent-at": "Submission Date",
      "archived-submissions.state": "Status",
      "archived-submissions.status": "ARCHIVED",
      "burden-selection-table.errore-in-creazione-pagamento": "An error occurred while creating the payment. Try again.",
      "change-submission-manager-button.input.can-submit.checkbox-text.permesso-di-invio": "Permission to Submit",
      "change-submission-manager-button.input.can-submit.help.permetti-al-procuratore-indicato-di-inviare-la-richiesta": "Allow the designated attorney to submit the request",
      "change-submission-manager-button.input.can-submit.label.invio-richiesta": "Request Submission",
      "change-submission-manager-button.input.file.label.documento-di-delega": "Delegation Document",
      "change-submission-manager-button.input.file.upload-button.icon-aria-label.carica": "Upload",
      "change-submission-manager-button.input.file.upload-button.title.carica-documento-di-delega": "Upload Delegation Document",
      "change-submission-manager-button.input.fiscal-code.label.codice-fiscale": "Fiscal Code or Email",
      "change-submission-manager-button.input.fiscal-code.placeholder.codice-fiscale": "Fiscal Code or Email",
      "change-submission-manager-button.message.error.nessun-id-della-richiesta-trovato": "No request ID found",
      "change-submission-manager-button.message.error.si-e-verificato-un-errore-riprovare": "An error occurred. Please try again.",
      "change-submission-manager-button.message.success.aggiornato-con-successo": "successfully updated",
      "change-submission-manager-button.subject-name.gestore": "Manager",
      "change-submission-manager-button.subject-name.procuratore": "Attorney",
      "change-submission-manager-button.title-prexix.assegna-un": "Assign",
      "change-submission-manager-button.title-prexix.cambia": "Change",
      "change-submission-manager.conferma-cambio-gestore": "Confirm Manager change",
      "change-submission-manager.sicuro-di-voler-sostituire-il-gestore": "Are you sure you want to replace the request Manager? Once the operation is completed, you might lose the ability to access the request.",
      "common.annulla": "Cancel",
      "communications.error-sending-communication": "An error occurred while sending the communication",
      "communications.message": "Message",
      "communications.message-placeholder": "Communication message",
      "communications.sent-successfully": "Communication sent successfully",
      "compilation-guide.avvia": "Start",
      "compilation-guide.domanda-non-trovata-in-archivio": "Request not found in archive id {{submissionId}}",
      "compilation-guide.impossibile-caricare-la-guida-alla-compilazione": "Unable to load the Request Guide",
      "compilation-module.impossibile-caricare-i-moduli": "Unable to load the Request Forms",
      "compilation-module.modulo-non-trovato": "Form not found",
      "compilation-module.modulo-salvato-con-successo": "Form saved successfully",
      "comunicazioni.invia": "Send",
      "create-request-button.error": "Error creating request",
      "delegate-username.nessuno": "None",
      "delegati-differenti-o-mancanti": "The forms have different or missing delegates",
      "delegation-column-base.delegati": "Delegates",
      "delegation-column-base.lettura": "Reading",
      "delegation-column-base.moduli": "Forms",
      "delegation-data-schema.abilita-compilazione": "Enable Compilation",
      "delegation-data-schema.abilita-firma": "Enable Signature",
      "delegation-data-schema.abilita-invio": "Enable Submission",
      "delegation-data-schema.codice-fiscale": "ID Code",
      "delegation-page.address-book.button-label": "Contacts",
      "delegation-page.attorney": "Attorney",
      "delegation-page.azioni": "Actions",
      "delegation-page.manager": "Manager",
      "delegation-page.title": "Delegation Management",
      "delegation-page.torna-alla-richiesta": "Back to Request",
      "delegation-schema.documento-di-delega": "Delegation Document",
      "delegation.errore": "An error occurred. Try again.",
      "delegation.modifica-deleghe-moduli-drawer.delega-di-compilazione": "Compilation Delegation",
      "delegation.modifica-deleghe-moduli-drawer.delega-di-firma": "Signature Delegation",
      "delegation.modifica-deleghe-moduli-drawer.delegati": "Delegates",
      "delegation.modifica-deleghe-moduli-drawer.deleghe-aggiornate": "Delegations updated successfully",
      "delegation.modifica-deleghe-moduli-drawer.deleghe-di-visualizzazione": "View Delegations",
      "delegation.modifica-deleghe-moduli-drawer.moduli-selezionati": "Selected Forms",
      "delegation.modifica-deleghe-moduli-drawer.titolo": "Form Delegation Management",
      "delegation.page.breadcrumb.gestione-deleghe": "Delegation",
      "delegation.page.breadcrumb.richieste": "Requests",
      "delegation.page.button.gestisci-selezionati": "Manage Selected",
      "delegation.page.delegation-table.button.gestisci": "Manage",
      "delegation.page.delegation-table.checkbox.seleziona-modulo": "Select Form",
      "delegation.page.delegation-table.checkbox.seleziona-tutti-i-moduli": "Select All Forms",
      "delegation.page.divider-title.deleghe-dei-moduli": "Form Delegations",
      "delegation.page.error.impossibile-caricare-le-deleghe-della-richiesta": "Unable to load request delegations",
      "domanda-copertina.accedi": "Access",
      "domanda.bottone-compilare-una-richiesta-per-titolare": "Only one request can be compiled per holder for this application",
      "domanda.bottone-crea-richiesta.sola-lettura": "It is currently not possible to fill out this form. Please try again later.",
      "domanda.bottone-crea-richiesta.vai-alla-compilazione": "Go to compilation",
      "domande.lista.elemento.alt-immagine.copertina-domanda": "Request Cover",
      "domande.lista.elemento.etichetta.scadenza": "Expiration",
      "domande.lista.elemento.pulsante.dettaglio-domanda": "Go to Procedure",
      "domande.lista.elemento.pulsante.vai-alla-domanda": "Go to Request",
      "domande.lista.pulsante.rimuovi-filtri": "Remove filters",
      "dossier-page.errore-caricamento-pratica": "An error occurred while loading your Request.",
      "dossiers-list.dossierss-list-title": "List of requests",
      "edit-modules-delegation-schema.delegati-alla-visualizzazione": "Delegates for viewing",
      "edit-modules-delegation-schema.delegato-alla-compilazione": "Delegate for compilation",
      "edit-modules-delegation-schema.delegato-alla-firma": "Delegate for signature",
      "errors-default.403.messaggio.non-autorizzato": "You do not have permissions to view the requested page.",
      "errors-default.403.titolo.non-autorizzato": "403 Not Authorized",
      "errors-default.404.messaggio.non-trovata": "Page Not Found.",
      "errors-default.404.titolo.non-trovato": "404 Not Found",
      "errors-default.500.messaggio.errore-interno-server": "An unexpected server error occurred. Please try again or contact support.",
      "errors-default.500.titolo.errore-interno-server": "500 Internal Server Error",
      "errors-default.generico.messaggio.errore-network": "An error occurred in the request.",
      "errors-default.generico.titolo.errore-network": "Network Error",
      "export.default-errore": "There was a problem downloading the file. Try again.",
      "export.file": "Requests_{{data}}.{{fileExtension}}",
      "export.file-non-trovato": "File not found",
      "extended-filters-schema.categorie": "Categories",
      "extended-filters-schema.codice-fiscale-titolare": "Holder ID Code",
      "extended-filters-schema.cognome-titolare": "Holder Surname",
      "extended-filters-schema.data-avvio-compilazione-a": "Compilation Start Date To",
      "extended-filters-schema.data-avvio-compilazione-da": "Compilation Start Date From",
      "extended-filters-schema.data-invio-compilazione-a": "Compilation Submission Date To",
      "extended-filters-schema.data-invio-compilazione-da": "Compilation Submission Date From",
      "extended-filters-schema.email-titolare": "Holder Email",
      "extended-filters-schema.nome-titolare": "Holder Name",
      "extended-filters-schema.stato-delega": "Delegation Status",
      "extended-filters-schema.stato-tipo-domanda": "Request Type Status",
      "extended-filters-schema.tipo-domanda": "Request Type",
      "extended-filters-schema.titolo-tipo-domanda": "Request Type Title",
      "extended-filters-schema.valori-ricerca-estesa": "Extended Search Values",
      "folder.data": "Date",
      "folder.data-documento": "Document Date",
      "folder.descrizione": "Description",
      "folder.nome": "Name",
      "folder.protocollo": "Protocol",
      "folder.tipo": "Type",
      "form.disable-submit-tooltip": "Submission is enabled only for the holder or attorney.",
      "form.errore-durante-invio": "An error occurred while sending",
      "form.form-cannot-send-as-delegate-tooltip": "You cannot submit this request as the delegation does not allow submission",
      "form.form-not-completed-tooltip": "Incomplete compilation",
      "form.form-not-payed-tooltip": "Missing payments",
      "form.indietro": "Back",
      "form.invia-la-domanda": "Submit Request",
      "form.invio-effettuato-con-successo": "Submission completed successfully",
      "front-user-menu.button.aria-label": "User Menu",
      "front-user-menu.button.piva-label": "VAT {{piva}}",
      "frontoffice.legal-entity-banner.change-profile": "Change profile",
      "frontoffice.legal-entity-banner.operating-as": "You are operating on behalf of",
      "frontoffice.legal-entity-banner.pg": "Legal Entity",
      "frontoffice.legal-entity-banner.pg-type": "Legal Entity {{type}}",
      "frontoffice.menu.profile.label": "Profile",
      "frontoffice.menu.profile.title": "Access Profile",
      "handle-modules-delegation-submit.id-richiesta-non-valido": "Invalid request ID. Try again.",
      "inquiry-cover.errore-caricamento-copertina-domanda": "Unable to load introduction page",
      "inquiry-cover.titolo-non-presente": "Title not present",
      "inquiry.ambito": "Scope",
      "inquiry.area-filter": "Administration",
      "inquiry.categorie": "Categories",
      "inquiry.cerca": "Search",
      "inquiry.destinatari": "Recipients",
      "inquiry.destinatari-bloccato-persona-giuridica": "Filter automatically set based on the Legal Entity you are operating for.",
      "inquiry.filtri": "Filters",
      "inquiry.filtri-di-ricerca": "Search filters",
      "inquiry.in-collaudo": "In testing",
      "inquiry.lista.briciole.domanda": "Request",
      "inquiry.lista.briciole.domande": "Requests",
      "inquiry.lista.errori.impossibile-caricare-la-sezione": "Unable to load the list of requests",
      "inquiry.lista.filtri-applicati.domande-mostrate-in-base-ai-filtri-di-ricerca": "requests found based on search filters.",
      "inquiry.lista.vuota.nessuna-domanda-da-mostrare": "No requests to show.",
      "inquiry.pubblicata": "Published",
      "inquiry.solo-attive": "Only Active",
      "inquiry.sotto-ambito": "Sub-Scope",
      "inquiry.stato": "Status",
      "inquiry.stato.aperta": "Open",
      "inquiry.stato.chiusa": "Closed",
      "inquiry.stato.in_corso": "In progress",
      "inquiry.stato.pubblicata": "Published",
      "inquiry.tipo-pubblicazione": "Publication Type",
      "inquiry.tipo-pubblicazione-filtro": "Publication",
      "inquiry.titolo": "Title",
      "inquiry.tutte-le-domande": "All Requests",
      "inserisci-cf-or-email-delegato": "Enter ID Code or Email for foreign user",
      "inserisci-codici-fiscali-o-email-delegati": "Enter ID Codes or Emails for foreign users",
      "integration-rows.nessuna-richiesta-attiva": "No active requests",
      "integration-rows.nessuna-richiesta-precedente": "No previous requests",
      "integration-rows.richieste-integrate": "Integrated Requests (list of previous requests)",
      "integration-rows.ultima-integrazione-della-richiesta": "Last request integration",
      "integration.data-creazione": "Creation Date:",
      "integration.data-invio": "Submission Date:",
      "integration.stato": "Status:",
      "integration.vai-alla-richiesta": "Go to request",
      "integration.vai-alla-richiesta-originale": "Go to the original request",
      "integration.vai-elenco-integrazioni": "Go to the list of integrations",
      "lang-long-name.en": "English",
      "lang-long-name.it": "Italian",
      "layout.footer.vai-all-inizio-pagina": "Go to the top of the page",
      "layout.header.menu-di.passa-alla-lingua": "Switch to language {{langName}}",
      "layout.header.menu-di.scelta-lingua": "Language selection menu",
      "layout.header.pulsante-notifiche_one": "{{count}} unread notification",
      "layout.header.pulsante-notifiche_other": "{{count}} unread notifications",
      "layout.skip-links.vai-al-contenuto-principale": "Go to main content",
      "layout.skip-links.vai-al-footer": "Go to Footer",
      "layout.skip-links.vai-al-menu-principale": "Go to main menu",
      "legal-entity.status-draft": "Draft",
      "legal-entity.status-revoked": "Revoked",
      "legal-entity.status-validated": "Validated",
      "legal-entity.type-private": "Private",
      "legal-entity.type-public": "Public",
      "login-button.accedi": "Access",
      "main-menu.mobile.aria-label": "Main Menu",
      "menu-items.guida-alla-compilazione": "Compilation guide",
      "menu-items.riepilogo": "Summary",
      "menu.category.sr-title": "Go to Requests in category {{category}}",
      "menu.istanze-archiviate": "Archived Requests",
      "menu.le-mie-pratiche": "My Practices",
      "menu.le-mie-pratiche.sr-title": "Go to My Practices",
      "menu.le-mie-richieste": "My Requests",
      "menu.le-mie-richieste.sr-title": "Go to My Requests",
      "menu.principal-menu": "Main Menu",
      "menu.tutte-le-domande": "All Requests",
      "menu.tutte-le-domande.sr-title": "Go to All Requests",
      "modifica-tutti": "Edit all",
      "module-listname.da-firmare": "To be signed",
      "module-tooltip-text.vai-al-modulo": "Go to the form to correct the errors.",
      "modules-delegations.view.abilita-deleghe": "Enable delegations",
      "modules-previous-delegations-summary.delegati-precedenti": "Previous delegates:",
      "observation-details.allegato-del-procedimento": "Procedure attachment",
      "observation-details.allegato-della-richiesta": "Request attachment",
      "observation-details.altri-titolari": "Other holders",
      "observation-details.apri-cartella": "Open folder {{recordName}}",
      "observation-details.apri-documento": "Open Document {{record}}",
      "observation-details.azioni": "Actions",
      "observation-details.chiudi-cartella": "Close folder {{recordName}}",
      "observation-details.comunicazione": "Communication",
      "observation-details.dati-della-richiesta": "Request Data",
      "observation-details.documenti": "Documents",
      "observation-details.documento": "Document",
      "observation-details.domanda": "Request",
      "observation-details.titolare": "Holder",
      "observation.area-pubblica": "Public Area",
      "observation.Cognome-titolare": "Holder Surname",
      "observation.data-invio": "Submission Date",
      "observation.data-protocollo": "Protocol Date",
      "observation.dati-del-procedimento": "Procedure Data",
      "observation.domanda": "Request",
      "observation.domande-trovate-in-base-ai-filtri-di-ricerca": "requests found based on search filters.",
      "observation.errore-durante-il-caricamento": "An error occurred while loading.",
      "observation.fine-osservazione": "Observation End",
      "observation.impossibile-caricare-elenco-area-pubblica": "Unable to load the Public Area list",
      "observation.inizio-osservazione": "Observation Start",
      "observation.numero-istanza": "Application Number",
      "observation.numero-procedimento": "Procedure Number",
      "observation.numero-protocollo": "Protocol Number",
      "observation.nuova-osservazione": "New Observation",
      "observation.oggetto": "Subject",
      "observation.oggetto-procedimento": "Request Subject",
      "observation.osservabile": "Observable",
      "observation.periodo-osservazione": "Observation period",
      "observation.procedimento": "Procedure",
      "observation.ricerca": "Search",
      "observation.rimuovi-filtri": "Remove filters",
      "observation.stato": "Status",
      "observation.titolare": "Holder",
      "observation.titolo-domanda": "Request Title",
      "observation.ufficio-responsabile": "Responsible Office",
      "payment.da-pagare-dopo-invio": "To be paid after submission",
      "possibile-modificare-tutti-i-moduli-con-un-nuovo-delegato": "You can edit all forms with a new delegate",
      "pratiche.dati": "Data",
      "pratiche.descriptions": "Practice Details",
      "pratiche.dettaglio": "Practice detail",
      "pratiche.pratiche": "Practices",
      "pratiche.submissions": "Requests",
      "progressive-number-filter.anno": "Year",
      "remove-submission-attorney-button.errore": "An error occurred. Try again.",
      "remove-submission-attorney-button.procuratore-rimosso-con-successo": "Attorney successfully removed",
      "remove-submission-attorney-button.rimuovere-attuale-procuratore": "Remove current Attorney?",
      "remove-submission-attorney-button.rimuovi-procuratore": "Remove Attorney",
      "reply-communication.create-error": "Unable to create the reply",
      "reply-communication.created": "Reply created successfully",
      "reply-communication.recipient": "Recipient",
      "reply-communication.title": "Reply to the communication",
      "richieste.firma.carica-documento-firmato-per-continuare": "Upload a signed document to continue",
      "richieste.firma.carica-e-completa": "Upload and Complete",
      "richieste.firma.messaggio-errore-caricamento-file": "Error during file upload, please retry",
      "richieste.firma.messaggio-successo-caricamento-file": "The signed file has been uploaded correctly.",
      "richieste.firma.procedura-firma-modulo": "Form signing procedure",
      "richieste.firma.scaricare-il-modulo-per-procedere-alla-firma": "Download the <title/> as PDF file, then add your digital signature to it and reload the signed file.",
      "selected-modules-text.moduli-selezionati": "{{selectedRows}} forms selected",
      "selected-modules-text.un-modulo-selezionato": "1 form selected",
      "shared-resource.document-id": "Document ID",
      "shared-resource.file-open": "Open",
      "shared-resource.files": "Attachments",
      "shared-resource.load-error": "We couldn't retrieve the document information.",
      "shared-resource.metadata": "Metadata",
      "shared-resource.no-files": "No file available for download",
      "shared-resource.page-title": "Document information",
      "shared-resource.portal-title": "Citizen services and procedures portal",
      "signed-module.documento-modulo-firmato": "Request form signed",
      "signed-module.errore-in-download-file": "There was a problem downloading the file. Try again.",
      "signed-module.file-non-trovato": "File not found",
      "submission-action-button.carica-documento-firmato-per-continuare": "Upload a signed document to continue",
      "submission-action-button.compilazione-terminata": "Filling completed",
      "submission-action-button.conferma-firma": "Confirm signature",
      "submission-action-button.errore": "An error occurred please try again",
      "submission-action-button.firma-delegata": "The signature is delegated to another user.",
      "submission-action-button.in-attesa-compilazione-delegato": "Awaiting filling by the delegate.",
      "submission-action-button.modulo-compilato": "The form has been filled out.",
      "submission-action-button.modulo-compilato-e-firmato": "The form has been filled out and signed. By returning to modify the form you will need to sign it again.",
      "submission-action-button.modulo-compilato-e-firmato-precedentemente": "The form has already been filled out and signed.",
      "submission-action-button.modulo-compilato-precedentemente": "The form has already been filled out.",
      "submission-action-button.modulo-compilato-ritornare-in-compilazione-per-modificare": "The form has been filled out you can return to editing it out if changes are necessary.",
      "submission-action-button.modulo-completato": "Completed form",
      "submission-action-button.modulo-non-valido": "The form is not valid",
      "submission-action-button.modulo-nuovamente-compilabile": "Form etitable again",
      "submission-action-button.modulo-pronto-per-la-firma": "Form ready for signature",
      "submission-action-button.per-procedere-alla-firma-segnare-come-pronto": "To proceed with digital signature mark the form as Ready for signature.",
      "submission-action-button.pronto-per-la-firma": "Ready for signature",
      "submission-action-button.ritorna-in-compilazione": "Return to compilation",
      "submission-action-button.salva-modulo": "Save the form to continue",
      "submission-action-button.se-completato-il-modulo-premi-compilazione-terminata": "If you have completed the form press the Completed button.",
      "submission-clone-button.chiudi": "Close",
      "submission-clone-button.duplica": "Duplicate",
      "submission-clone-button.duplica-richiesta": "Duplicate Request",
      "submission-clone-button.errore-durante-la-duplicazione-della-richiesta": "An error occurred while duplicating the request.",
      "submission-clone-button.errore-nel-duplicare-la-richiesta": "Error duplicating the request",
      "submission-clone-button.la-richiesta-deve-essere-salvata-per-duplicare": "The request must be saved to be duplicated.",
      "submission-clone-button.la-richiesta-verra-duplicata-senza-i-file-allegati": "The request will be duplicated without attached files.",
      "submission-clone-button.richiesta-duplicata-con-successo": "Request duplicated successfully.",
      "submission-clone-button.sei-sicuro-di-voler-duplicare-la-richiesta": "Are you sure you want to duplicate the request?",
      "submission-columns.bozza": "Draft",
      "submission-columns.conclusa": "Concluded",
      "submission-columns.creata": "Created",
      "submission-columns.data-creazione": "Creation date",
      "submission-columns.data-invio": "Submission date",
      "submission-columns.data-modifica": "Modification date",
      "submission-columns.domanda": "Request",
      "submission-columns.fase": "Phase",
      "submission-columns.integrata": "Integrated",
      "submission-columns.inviata": "Submitted",
      "submission-columns.numero-istanza": "Instance Number",
      "submission-columns.numero-protocollo": "Protocol Number",
      "submission-columns.oggetto": "Subject",
      "submission-columns.ricevuta": "Received",
      "submission-columns.stato": "Status",
      "submission-columns.titolare": "Holder",
      "submission-delegation-drawer.abilita-compilazione-della-richiesta": "Enable to edit request",
      "submission-delegation-drawer.abilita-firma-della-richiesta": "Enable to sign request",
      "submission-delegation-drawer.abilita-invio-della-richiesta": "Enable to submit request",
      "submission-delegation-drawer.annulla": "Cancel",
      "submission-delegation-drawer.carica-documento-di-delega": "Upload Delegation Document",
      "submission-delegation-drawer.codice-fiscale-partita-iva": "Tax code/VAT number",
      "submission-delegation-drawer.delega-inviata-con-successo": "Delegation sent successfully",
      "submission-delegation-drawer.delega-richiesta": "Delegate request",
      "submission-delegation-drawer.documento-di-delega": "Delegation document",
      "submission-delete-delegation-button.codice-fiscale-delegato": "Delegate {{delegateFiscalCode}}",
      "submission-delete-delegation-button.delega-rimossa-con-successo": "Delegation removed successfully ",
      "submission-delete-delegation-button.rimuovi-delega": "Remove delegation",
      "submission-delete-delegation-button.sicuro-di-voler-rimuovere-delega": "Are you sure you want to remove this delegation?",
      "submission-details.comunicazioni": "Communications",
      "submission-details.comunicazioni-aria-label": "Communications. Tab {{tabNumber}} of {{totalTabs}}",
      "submission-details.integrazioni": "Integrations",
      "submission-details.integrazioni-aria-label": "Integrations. Tab {{tabNumber}} of {{totalTabs}}",
      "submission-details.la-mia-richiesta": "My request",
      "submission-details.la-mia-richiesta-aria-label": "My request. Tab {{tabNumber}} of {{totalTabs}}",
      "submission-details.pagamenti": "Payments",
      "submission-details.pagamenti-aria-label": "Payments. Tab {{tabNumber}} of {{totalTabs}}",
      "submission-details.ricevuta-invio": "Submission receipt",
      "submission-details.ricevuta-invio-aria-label": "Submission receipt. Tab {{tabNumber}} of {{totalTabs}}",
      "submission-filter-form-mobile.codice-fiscale-titolare": "Holder Tax Code",
      "submission-filter-form-mobile.cognome-titolare": "Holder Surname",
      "submission-filter-form-mobile.nome-titolare": "Holder Name",
      "submission-filter.categorie": "Categories",
      "submission-filter.codice-fiscale-titolare": "Holder Tax Code",
      "submission-filter.cognome-titolare": "Holder Surname",
      "submission-filter.nome-titolare": "Holder Name",
      "submission-filter.ricerca-estesa": "Extended Search",
      "submission-filter.seleziona-le-categorie": "Select categories",
      "submission-filter.stato-delega": "Delegation Status",
      "submission-form.compilazione-richiesta-incompleta": "Request Compilation Incomplete",
      "submission-form.errore-in-caricamento-domanda": "An error occurred during request loading.",
      "submission-form.errore-in-caricamento-richiesta": "An error occurred during request loading.",
      "submission-form.errore-moduli-incompleti-per-poter-procedere": "Some forms are incomplete or have errors. All forms must be compiled to proceed with submission.",
      "submission-form.errore-oneri-non-pagati-per-poter-procedere": "Some charges are unpaid. All mandatory charges must be compiled to proceed with submission.",
      "submission-form.id-della-richiesta-non-valido": "Invalid request ID",
      "submission-form.integrazione-di-un-altra-richiesta": "This is an integration of another request.",
      "submission-form.inviare-per-procedere-al-pagamento": "Proceed with Request Submission to make charge payments.",
      "submission-form.invio-in-corso": "Submission in progress...",
      "submission-form.richieste": "Requests",
      "submission-form.stato-pagamenti-incompleto": "Payment status incomplete",
      "submission-integration-button.avvia": "Start",
      "submission-integration-button.integra-la-richiesta": "Integrate the Request",
      "submission-integration-button.sicuro-avviare-integrazione": "Are you sure you want to start the integration?",
      "submission-linked-button.visualizza-richiesta": "View request",
      "submission-list.apri-pagina-dettaglio-richiesta": "Open the request detail page",
      "submission-list.domande-trovate-in-base-ai-filtri": "requests found based on search filters.",
      "submission-list.duplica-richiesta": "Duplicate request",
      "submission-list.errore-eliminazione-richiesta": "Error deleting request",
      "submission-list.header-col.actions": "Actions",
      "submission-list.impossibile-caricare-elenco-richieste": "Unable to load request list",
      "submission-list.richiesta-eliminata-con-successo": "Request deleted successfully ",
      "submission-list.richieste": "Requests",
      "submission-list.rimuovi-filtri": "Remove filters",
      "submission-list.search": "Search",
      "submission-list.submissions-list-title": "Request List",
      "submission-list.visualizza-richiesta": "View request",
      "submission-module.il-gestore": "the Manager",
      "submission-module.il-procuratore": "the Attorney",
      "submission-module.il-titolare": "the Holder",
      "submission-module.modulo-completato": "The form is completed.",
      "submission-module.modulo-disponibile-alla-firma-al-termine-della-compilazione": "The form will be available for signature after compilation.",
      "submission-module.necessario-compilare-il-modulo": "The form must be compiled.",
      "submission-module.necessario-firmare-il-modulo": "The form must be signed.",
      "submission-module.permesso-utente-modulo": "You have permission to <permissionsText/> this Form.",
      "submission-module.riepilogo-modulo": "Form Summary",
      "submission-module.ruolo-utente-della-richiesta": "You are the <roleText/> of the Request.",
      "submission-module.stai-visualizzando-in-sola-lettura-il-modulo": "You are viewing this form in read-only mode.",
      "submission-module.un-delegato": "a Delegate",
      "submission-payment.conferma-a-procedere": "Are you sure you want to proceed?",
      "submission-payment.rieffettuare-il-pagamento-a-seguito-di-riportare-in-bozza": "Bringing the request back to draft will invalidate <bold>all paid stamps</bold> and require re-payment.",
      "submission-payments.annulla-pagamenti-e-torna-in-bozza": "Cancel payments and revert to draft",
      "submission-payments.errore": "An error occurred while updating the request status",
      "submission-payments.inviare-o-riportare-in-bozza": "Your request has been paid. You can either submit it, or revert it to draft to make changes by canceling the paid stamps.",
      "submission-payments.pagare-o-riportare-in-bozza": "Your request is in payment. Once the stamps are paid, you can submit it; otherwise, you can revert it to draft to make changes.",
      "submission-payments.riporta-in-bozza": "Revert to draft",
      "submission-searchable-fields.anno-istanza": "Instance Year ",
      "submission-searchable-fields.bozza": "Draft",
      "submission-searchable-fields.categoria": "Category",
      "submission-searchable-fields.codice-fiscale-titolare": "Holder ID Code",
      "submission-searchable-fields.cognome-titolare": "Holder Surname",
      "submission-searchable-fields.conclusa": "Concluded",
      "submission-searchable-fields.data-avvio-compilazione-al": "Compilation Start Date To",
      "submission-searchable-fields.data-avvio-compilazione-dal": "Compilation start date from",
      "submission-searchable-fields.data-creazione": "Creation date",
      "submission-searchable-fields.data-invio": "Submission Date",
      "submission-searchable-fields.data-invio-al": "Submission Date To",
      "submission-searchable-fields.data-invio-dal": "Submission Date From",
      "submission-searchable-fields.integrata": "Integrated",
      "submission-searchable-fields.inviata": "Submitted",
      "submission-searchable-fields.nome-titolare": "Holder Name",
      "submission-searchable-fields.numero-istanza": "Instance Number",
      "submission-searchable-fields.oggetto": "Subject",
      "submission-searchable-fields.ricerca-estesa": "Extended Search",
      "submission-searchable-fields.ricevuta": "Receipt",
      "submission-searchable-fields.seleziona-le-categorie": "Select categories",
      "submission-searchable-fields.stato-delega": "Delegation Status",
      "submission-searchable-fields.stato-richiesta": "Request Status",
      "submission-searchable-fields.tipo-domanda": "Request Type",
      "submission-searchable-fields.titolo-tipo-domanda": "Request Type Title",
      "submission-sent-form.apri-integrazione-in-bozza": "Open Draft Integration",
      "submission-sent-form.errore-in-caricamento-domanda": "An error occurred while loading the question.",
      "submission-sent-form.errore-in-caricamento-richiesta": "An error occurred while loading the request.",
      "submission-sent-form.errore-in-integrazione-richiesta": "An error occurred while integrating your request please try again.",
      "submission-sent-form.id-della-richiesta-non-valido": "Invalid request ID",
      "submission-sent-form.integrazione-creata-con-successo": "Integration created successfully",
      "submission-sent-form.integrazione-di-un-altra-richiesta": "This is an integration of another request.",
      "submission-sent-form.integrazione-in-bozza": "A draft integration for this request exists.",
      "submission-sent-form.richiesta-integrata": "This request has been integrated.",
      "submission-sent-form.richieste": "Requests",
      "submission-sent-form.tabs-row.aria": "Navigation between the tabs of the sent request",
      "submission-sent-tab-communications.comunicazione-creata-con-successo": "Communication created successfully ",
      "submission-sent-tab-communications.comunicazione-eliminata-con-successo": "Communication deleted successfully ",
      "submission-sent-tab-communications.comunicazione-modificata-con-successo": "Communication modified successfully ",
      "submission-sent-tab-communications.comunicazioni-trovate-in-base-ai-filtri": "communications found based on search filters.",
      "submission-sent-tab-communications.errore-caricamento-allegato": "Unable to load attachment",
      "submission-sent-tab-communications.errore-caricamento-comunicazioni": "Unable to load communications",
      "submission-sent-tab-communications.errore-creazione-comunicazione": "Unable to create communication",
      "submission-sent-tab-communications.errore-eliminazione-comunicazione": "Unable to delete communication",
      "submission-sent-tab-communications.errore-modifica-comunicazione": "Unable to modify communication",
      "submission-sent-tab-communications.errore-rimozione-allegato": "Unable to remove attachment",
      "submission-sent-tab-communications.errore-tab-comunicazioni": "An error occurred",
      "submission-sent-tab-communications.nuova-comunicazione": "New Communication",
      "submission-sent-tab-communications.panel-aria": "Communications tab",
      "submission-sent-tab-communications.rimuovi-filtri": "Remove filters",
      "submission-sent-tab-integrations.panel-aria": "Integrations tab",
      "submission-sent-tab-payment.panel-aria": "Payments tab",
      "submission-sent-tab-recipt.panel-aria": "Receipt tab",
      "submission-sent-tab-sent-request.panel-aria": "Sent Request tab",
      "submission-summary.riepilogo-richiesta": "Request Summary",
      "submission-summary.stato-oneri": "Payments Status",
      "submission.altri-titolari": "Other holders",
      "submission.button.button-delete-modal.elimina-richiesta": "Delete request",
      "submission.button.button-delete-modal.la-richiesta-deve-essere-salvata-per-essere-eliminata": "The request must be saved before it can be deleted.",
      "submission.button.button-delete-modal.modal-button.chiudi": "Close",
      "submission.button.button-delete-modal.sei-sicuro-di-voler-eliminare-la-richiesta": "Are you sure you want to delete the request?",
      "submission.codice-richiesta": "Request code:",
      "submission.data-invio": "Submission Date:",
      "submission.data-protocollo": "Protocol date:",
      "submission.delegation-banner.stai-commpilando-in-delega-la-richiesta": "You are viewing this request as a delegate.",
      "submission.delegation-button": "Delegate the Request",
      "submission.documento-firmato": "Signed Document",
      "submission.numero-procedimento": "Procedure number:",
      "submission.numero-protocollo": "Protocol number:",
      "submission.oggetto-richiesta": "Subject:",
      "submission.richiesta-inviata-con-successo": "Request submitted successfully!",
      "submission.richiesta-inviata-correttamente-da-prendere-in-carico": "The request has been correctly submitted and will be processed shortly.",
      "submission.salva-modulo-per-caricare-file-firmato": "Save the form to upload the signed file",
      "submission.seleziona-file-firmato": "Select signed file...",
      "submission.stato-richiesta": "Request status:",
      "submission.vai-ai-pagamenti": "Go to the Payments section to view and manage the quote",
      "tag-options.delegato": "Delegate",
      "tag-options.gestore": "Manager",
      "tag-options.procuratore": "Attorney",
      "tag-options.titolare": "Holder",
      "tag-options.utente": "User",
      "ui.apri-pannello-ricerca": "Open search panel",
      "ui.cerca": "Search",
      "ui.filtri-di-ricerca": "Search filters",
      "ui.nessun-filtro-modificato": "No filters changed",
      "ui.rimuovi-filtri": "Remove Filters",
      "update-delegation-data-schema.abilita-delega": "Enable delegation",
      "update-delegation-data-schema.conferma-modifica": "Confirm change",
      "update-delegation-data-schema.delegato": "Delegate",
      "user-profile-nationality.EU": "eIDAS countries",
      "user-profile-nationality.extra-EU": "Other countries",
      "user-profile-nationality.italy": "Italian",
      "user-registration-form.divider-title": "Personal data",
      "user-registration-form.email": "E-mail",
      "user-registration-form.nationality": "Nationality",
      "user-registration-form.nationaly-eidas-help": "You can consult <2>the list of countries that support eIDAS Login for Italy</2>.",
      "user-registration-form.password": "Password",
      "user-registration-form.password-confirm": "Confirm Password",
      "user-registration-form.password-confirm-error": "Passwords do not match.",
      "user-registration-form.profile.agreement": "Consent",
      "user-registration-form.profile.country": "Country of birth",
      "user-registration-form.profile.country-of-birth": "Province of birth",
      "user-registration-form.profile.county-of-birth": "Province of birth",
      "user-registration-form.profile.date-of-birth": "Date of birth",
      "user-registration-form.profile.familyName": "Surname",
      "user-registration-form.profile.fiscal-number": "Tax Code",
      "user-registration-form.profile.mobile-phone": "Mobile phone",
      "user-registration-form.profile.name": "Name",
      "user-registration-form.profile.place-of-birth": "Place of birth",
      "user-registration-form.profile.privacy-policy": "You must accept the privacy policy",
      "user-registration-form.top-title": "Access Data",
      "user-registration.back-to-login": "Return to login",
      "user-registration.country.unkown": "Unknown",
      "user-registration.form.privacy-acceptance": "Acceptance",
      "user-registration.form.submit-button": "Register",
      "user-registration.ue-citizen-message": "Are you a Italian or EU citizen? Log in with SPID/CIE or eIDAS.",
      "user.activation.breadcrumb": "User Activation",
      "user.activation.error.id": "Activation ID not valid",
      "user.activation.error.token": "Invalid token",
      "user.activation.response.error.back-button": "Back to Login",
      "user.activation.response.error.sub-title": "Email verification failed.",
      "user.activation.response.error.title": "Email verification error",
      "user.activation.response.success.sub-title": "Log in with the email and password entered in the registration form.",
      "user.activation.response.success.submit-button": "Go to Login",
      "user.activation.response.success.title": "Registration Completed!",
      "user.activation.submit-button": "Activate User",
      "user.activation.text": "Click the button below to complete your Email Verification.",
      "user.activation.title": "Verify Email",
      "user.breadcrumb.profilo": "Profile",
      "user.card-title.profilo-utente": "User Profile",
      "user.change-password": "Change Password",
      "user.conferma-password": "Confirm Password",
      "user.current-password": "Current Password",
      "user.errore-in-verifica-mail": "Email verification error",
      "user.forgot-password.api-error-generic": "An error occurred during password recovery. Please retry.",
      "user.forgot-password.breadcrumb": "Reset password",
      "user.forgot-password.button-text": "Send me an email",
      "user.forgot-password.text": "Enter the email you registered with. You will receive a link to reset your password via email.",
      "user.forgot-password.title": "Forgot Password?",
      "user.front-login.select-pg.act-as": "Operate on behalf of {{name}}",
      "user.front-login.select-pg.back-to-login": "Back to login",
      "user.front-login.select-pg.breadcrumb": "Log in as",
      "user.front-login.select-pg.generic-error": "An error occurred. Please try again.",
      "user.front-login.select-pg.page-title": "Choose the identity to log in with.",
      "user.front-login.select-pg.self-option": "Myself",
      "user.front-login.select-pg.self-subtitle": "Log in as a natural person",
      "user.front-login.select-pg.session-expired": "Session expired. Please log in again.",
      "user.front-login.select-pg.subtitle": "Select the profile you want to operate with",
      "user.front-login.select-pg.title": "Log in as",
      "user.front-login.select-pg.vat-number": "VAT:",
      "user.le-password-non-coincidono": "Passwords do not match.",
      "user.new-password": "New Password",
      "user.password": "Password",
      "user.password-change.breadcrumb": "Change Password",
      "user.password-change.error.message": "Unable to change password.",
      "user.password-change.form.password-confirm": "Confirm Password",
      "user.password-change.form.password-repeat": "Repeat Password",
      "user.password-change.form.submit-button": "Change Password",
      "user.password-change.response.error.sub-title": "Unable to reset password.",
      "user.password-change.response.error.title": "Password Change Error",
      "user.password-change.response.success.back-to-inquiry": "Back to Requests",
      "user.password-change.response.success.submit-button": "Back to Profile",
      "user.password-change.response.success.title": "Password changed successfully",
      "user.password-change.success": "Password Modified",
      "user.password-change.text": "Enter the new password for the user",
      "user.password-change.title": "Modify Password",
      "user.password-reset-request.response.success.button-login": "Back to Login",
      "user.password-reset-request.response.success.subtitle": "Check your email inbox. We sent you an email with instructions to reset your password.",
      "user.password-reset-request.response.success.title": "Password change request sent",
      "user.password-reset.breadcrumb": "Reset Password",
      "user.password-reset.error.id": "Verification ID not valid",
      "user.password-reset.error.message": "Unable to reset the password.",
      "user.password-reset.error.token": "Invalid token",
      "user.password-reset.form.password-confirm": "Repeat Password",
      "user.password-reset.form.submit-button": "Reset Password",
      "user.password-reset.response.error.sub-title": "Unable to reset the password.",
      "user.password-reset.response.error.title": "Password Reset Error",
      "user.password-reset.response.success.button-login": "Log in",
      "user.password-reset.response.success.submit-button": "Back to Login",
      "user.password-reset.response.success.title": "Password reset successfully!",
      "user.password-reset.success": "Password reset successfully!",
      "user.password-reset.text": "Enter the new password for the user",
      "user.password-reset.title": "Reset password",
      "user.profile.form.submit-button": "Save Changes",
      "user.profile.legal-entity.business-name": "Business name",
      "user.profile.legal-entity.pec": "PEC",
      "user.profile.legal-entity.registered-office": "Registered office",
      "user.profile.legal-entity.section-title": "Legal Entity data",
      "user.profile.legal-entity.status": "Status",
      "user.profile.legal-entity.type": "Type",
      "user.profile.legal-entity.vat-number": "VAT number",
      "user.profile.operator.email": "Email",
      "user.profile.operator.family-name": "Last name",
      "user.profile.operator.name": "First name",
      "user.profile.operator.section-title": "Operator data",
      "user.profile.update-error": "Error updating user profile.",
      "user.profile.update-success": "User profile updated successfully.",
      "user.registration.breadcrumb": "User Registration",
      "user.registration.email-validation.message": "Hello <1>{{fullName}}</1>, authentication was successful. Enter your email to complete your profile and proceed with online services access.",
      "user.registration.email-validation.response.success.sub-title-generic": "To activate the user, follow the instructions we sent via email.",
      "user.registration.email-validation.response.success.title": "Registration Completed Successfully!",
      "user.registration.form.privacy-acceptance-text": "I consent to the processing of personal data.",
      "user.registration.form.submit-button": "Register",
      "user.registration.form.top-title": "Access Data",
      "user.registration.response.error.message": "An error occurred during registration",
      "user.registration.response.success.sub-title": "We sent you an email with instructions to activate your account. Once activated, you can log in to the portal.",
      "user.registration.response.success.submit-button": "Back to Requests",
      "user.registration.response.success.title": "Registration Completed!",
      "verification-labels.click-sul-pulsante-per-completare-l-verifica": "To complete verification click the button",
      "verification-labels.click-sul-pulsante-per-completare-la-verifica": "To complete email verification click the button",
      "verification-labels.verifica": "Verify",
      "verification-labels.verifica-email": "Verify Email",
      "verification-page.errore-durante-la-verifica": "A problem occurred during verification",
      "verification-page.errore-in-verifica": "Verification Error",
      "verification-page.verifica": "Verify",
      "verification-result-info.errore-in-verifica": "Verification Error",
      "verification-result-info.verifica-completata-con-successo": "Verification completed successfully",
      "verification-result-info.verifica-completata-con-warning": "Verification completed with warning",
      "collapse.search-collapse-container.header": "Extended Search Panel",
      "task-card.outcomes.title": "Results",
      "task.payment-type.taxable": "Taxable Amount",
      "task.payment-type.total": "Total",
      "task.payment-type.vat": "VAT",
      "verification.c020.breadcrumb": "Verification of Residence",
      "verification.c020.form.citizenRegistry": "Search by Citizen Registry",
      "verification.c020.form.citizenRegistry.label.cognome": "Surname",
      "verification.c020.form.citizenRegistry.label.datiNascita.dataEvento": "Date of Birth",
      "verification.c020.form.citizenRegistry.label.datiNascita.luogoNascita.comune": "Town of Birth",
      "verification.c020.form.citizenRegistry.label.datiNascita.luogoNascita.localita": "Country of Birth",
      "verification.c020.form.citizenRegistry.label.datiNascita.luogoNascita.provincia": "Province Code",
      "verification.c020.form.citizenRegistry.label.luogoNascita.locationType": "Birthplace Type",
      "verification.c020.form.citizenRegistry.label.nome": "First Name",
      "verification.c020.form.citizenRegistry.label.sesso": "Gender",
      "verification.c020.form.fiscalCodeSearch": "Search by Tax Code",
      "verification.c020.form.fiscalCodeSearch.label.codiceFiscale": "Tax Code",
      "verification.c020.form.idANPRSearch": "Search by ANPR ID",
      "verification.c020.form.idANPRSearch.label.idANPR": "ANPR ID",
      "verification.c020.label.scelta-tipo-di-verifica": "Select type of verification:",
      "verification.c020.page.title": "Verification of Residence",
      "verification.c020.radio.option.per-anagrafica-del-cittadino": "By Citizen Registry",
      "verification.c020.radio.option.per-codice-fiscale": "By Tax Code",
      "verification.c020.radio.option.per-id-anpr": "By ANPR ID",
      "scope.ambito-modificato-con-successo": "Scope modified successfully",
      "scope.errore-in-modifica-ambito": "An error occurred while modifying the Scope",
      "array.max": "The field ${path} must have at most ${max} items",
      "array.min": "The field ${path} must have at least ${min} items",
      "mixed.default": "The field ${path} is not valid",
      "mixed.defined": "The field ${path} is required",
      "mixed.notNull": "The field ${path} cannot be empty",
      "mixed.notOneOf": "The field ${path} must not have any of the following values: ${values}",
      "mixed.oneOf": "The field ${path} must have one of the following values: ${values}",
      "mixed.required": "The field ${path} is required",
      "notType.default": "The field {{path}} is not valid",
      "notType.number": "The field {{path}} must be a number",
      "notType.string": "The field {{path}} must be a string",
      "number.integer": "The field ${path} must be an integer",
      "number.lessThan": "The field ${path} must be less than ${less}",
      "number.max": "The field ${path} must be less than or equal to ${max}",
      "number.min": "The field ${path} must be greater than or equal to ${min}",
      "number.moreThan": "The field ${path} must be greater than ${more}",
      "number.negative": "The field ${path} must be a negative number",
      "number.positive": "The field ${path} must be a positive number",
      "string.email": "The field ${path} must be a valid email",
      "string.length": "The field ${path} must be exactly ${length} characters long",
      "string.lowercase": "The field ${path} must contain only lowercase characters",
      "string.matches": "The field ${path} must match the following pattern: \"${regex}\"",
      "string.max": "The field ${path} must have at most ${max} characters",
      "string.min": "The field ${path} must have at least ${min} characters",
      "string.trim": "The field ${path} must be text without leading or trailing spaces",
      "string.uppercase": "The field ${path} must contain only uppercase characters",
      "string.url": "The field ${path} must be a valid URL",
      "advanced-search.collapse-form-messagge": "results found based on search filters.",
      "advanced-search.filtri": "Filters",
      "advanced-search.remove-filters": "Remove filters",
      "advanced-search.tag-semantici": "Other specialized fields",
      "alert.alert-error-body.message": "An error occurred in your request.",
      "alert.error-result-body.message": "An error occurred in your request.",
      "alert.error-result-body.title": "Network Error",
      "alert.forbidden-body.message": "You do not have permission to view the requested page.",
      "alert.forbidden-body.title": "403 Unauthorized",
      "alert.internal-error-body.subtitle": "An unexpected server error occurred. Please try again or contact support.",
      "alert.internal-error-body.title": "500 Internal Server Error",
      "alert.not-found-body.subtitle": "Page Not Found.",
      "alert.not-found-body.title": "404 Not Found",
      "button.button-delete-confirm.content": "Delete",
      "button.button-delete-confirm.icon-aria": "Delete item",
      "button.button-delete-confirm.ok": "Delete",
      "button.button-delete-confirm.title": "Are you sure you want to delete this item?",
      "button.button-delete-confirm.tooltip": "Delete item",
      "button.confirm-button.cancel": "Cancel",
      "button.confirm-button.confirm": "Confirm",
      "button.confirm-button.title": "Are you sure you want to continue with the operation?",
      "button.content-hover-edit": "Edit",
      "button.content-hover-edit-config-mode": "Edit",
      "card.network-responsive-card.error": "Error",
      "collapse.collapsible-area.hidden-header": "Collapsible Area",
      "collapse.desktop-filter-panel.title": "Extended search filters",
      "collapse.filter-button.content": "Extended Search",
      "collapse.filter-button.tooltip": "Active search filters",
      "collapse.filter-button.tooltip-aria": "Active search filters",
      "collapse.filter-panel.clear": "Clear",
      "collapse.filter-panel.search": "Search",
      "collapse.filtri-di-ricerca": "Search Filters",
      "collapse.ghost-collapse.header": "Ghost Extend Collapse",
      "common.paginazione.aria-label": "Pagination",
      "common.paginazione.precedente": "Go to previous page",
      "common.paginazione.successiva": "Go to next page",
      "countdown-humanized.days": "days",
      "countdown-humanized.label": "Time remaining",
      "countdown-humanized.label.dd": "dd",
      "countdown-humanized.label.hh": "hh",
      "countdown-humanized.label.mm": "mm",
      "countdown-humanized.label.ss": "ss",
      "countdown-humanized.more-months": "More than two months",
      "countdown-humanized.more-years": "More than a year",
      "countdown-humanized.sr-text": "{{dd}} days, {{hh}} hours, {{mm}} minutes, {{ss}} seconds",
      "drawer.close-aria": "Close Panel",
      "dropdown.risultati-per-ricerca": "Results for \"{{search}}\"",
      "dropdown.search-dropdown.no-reseults": "No results found",
      "dropdown.search-dropdown.search": "Write to start searching",
      "file-row.file-uploaded-prefix": "File uploaded: ",
      "html.head.title": "Procedures Portal | Frontoffice",
      "layout.page-layout-base.top-bar-aria": "Go to page top",
      "loader.loader-spin.icon-aria": "Loading...",
      "message-filtered-list.invisible.sr-default-message": "No filters applied",
      "moddal.modal-confirm.delete": "Delete",
      "route-announcer.nav-to-page": "Navigated to {{title}}",
      "router.breadcrumbs.home-aria": "Home",
      "router.breadcrumbs.nav-aria-label": "breadcrumb navigation",
      "search.advanced-search.filter-add.label": "Add Filter",
      "search.advanced-search.filter-add.select-placeholder": "Add Filter",
      "search.component.advanced-search-field.date.placeholder-fallback": "DD/MM/YYYY",
      "search.component.search-actions.reset-button.text": "Remove filters",
      "search.component.search-actions.save-filter-button.arial-label": "Save Filter Selection",
      "search.component.search-actions.save-filter-button.tooltips": "Save Filter Selection",
      "search.component.search-actions.submit-button.pristine-message": "No filters selected",
      "search.component.search-actions.submit-button.text": "Search",
      "search.component.search-row.remove-filter-button.aria-label": "Remove Filter",
      "search.component.search-row.remove-filter-button.tooltips": "Remove Filter",
      "skip-links.open-menu": "Open Skip Link navigation menu",
      "table.copyable-id.copied": "ID {{id}} copied!",
      "table.copyable-id.copy": "Copy ID {{id}}",
      "table.copyable-id.no-id": "ID not present!",
      "table.filter-dropdown-search.reset": "Reset",
      "table.filter-dropdown-search.search": "Search",
      "table.table-column-filter-buttons.reset": "Reset",
      "table.table-column-filter-buttons.search": "Search",
      "table.table-column-filter.date-range-from-placeholder": "From: DD/MM/YYYY",
      "table.table-column-filter.date-range-to-placeholder": "To: DD/MM/YYYY",
      "table.table-column-filter.text-placeholder": "Search",
      "table.table-data-filter-panel.reset": "Reset",
      "table.table-data-filter-panel.search": "Search",
      "table.table-date-from.from": "From",
      "ui.ellipsis.collapse": "collapse",
      "ui.ellipsis.expand": "expand",
      "use-pagination-a11y.a-pagina": "on page",
      "use-pagination-a11y.button.pagina-corrente": "Page {{page}}, current page",
      "use-pagination-a11y.button.vai-alla-pagina": "Go to page {{page}}",
      "use-pagination-a11y.current-page-sr-message": "Current page {{page}}.",
      "use-pagination-a11y.current-page-sr-message-total": "Current page {{page}} of {{total}}.",
      "use-pagination-a11y.dimensioni-della-pagina": "Page size. {{size}} items on page selected.",
      "use-pagination-a11y.navigazione-pagine-pagina-corrente": "Pages navigation. Current page: {{current}}.",
      "use-pagination-a11y.pagina": "page",
      "use-pagination-a11y.total-info-sr": "From {{start}} to {{end}} of {{total}} total items.",
      "use-pagination-a11y.total-info.di": "of",
      "carenza": "Shortage",
      "eccedenza": "Surplus",
      "error-submit-vote-widget.errore-invio-voto": "An error occurred while submitting the vote. Please try again.",
      "error-submit-vote-widget.id-richiesta-mancante": "Unable to submit vote: Request ID not available",
      "footer.address": "<0>Via del Collegio Romano, 27</0><1>00186 Roma</1><2>Phone: (+39) 06.6723.1</2>",
      "footer.address-title": "MiC Headquarters",
      "footer.policy.accessibility-declaration-text": "Accessibility statement",
      "footer.policy.privacy-cookie-policy-text": "Privacy and cookie policy",
      "footer.static-text": "MiC - Direzione Generale Risorse Umane e Organizzazione",
      "footer.transparent-administration-label": "Transparent Administration",
      "front-footer-numero-verde.alt": "Toll-Free Number 800 991199 Transparent Administration | Ministry of Culture",
      "logo.front-name.servizi-online": "Services",
      "mic.front-footer-logo.alt": "Ministry of Culture logo",
      "mic.logo-nextgenerationeu.alt": "Funded by the European Union - NextGenerationEU logo",
      "multi-preference-widget.add": "Add",
      "multi-preference-widget.drag-to-sort": "Drag to sort",
      "multi-preference-widget.remove-row": "Remove",
      "siap-data-columns-carenza-eccedenza": "Shortage/Surplus",
      "siap-data-columns-organico-di-diritto": "Official Staff",
      "siap-data-columns.organico-di-fatto": "Actual Staff",
      "siap-data-columns.profile": "Profile",
      "siap-data-table.codice-aoo": "AOO code",
      "siap-data-table.data-riferimento": "Reference Date",
      "siap-data-table.istituto": "Institute",
      "siap-data-table.regione": "Region",
      "siap-data-widget.error-message": "Error loading data",
      "siap-data-widget.error-message-description": "An error occurred while loading data from SIAP. Please try again later.",
      "success-submit-vote-widget.torna-alle-istanze": "Back to Requests",
      "success-submit-vote-widget.voto-inviato": "Vote submitted successfully",
      "user.front-login.cie-link.info": "More information about CIE",
      "user.front-login.cie-link.info-url": "https://www.cartaidentita.interno.gov.it/en/",
      "user.front-login.cns-link.info": "More information about CNS",
      "user.front-login.cns-link.info-url": "https://www.agid.gov.it/en/piattaforme/national-service-card",
      "user.front-login.page-title.h1.login-page": "Login Page.",
      "user.front-login.spid-link.info": "More information about SPID",
      "user.front-login.spid-link.info-url": "https://www.spid.gov.it/en/",
      "user.front-login.spid-professionale-link.info": "More information about Professional SPID",
      "user.front-login.spid-professionale-link.info-url": "https://www.spid.gov.it/aziende/",
      "user.front-login.text.cie": "CIE (Electronic Identity Card) is the Italian electronic ID card that, in addition to certifying a citizen's identity, enables access to digital Public Administration services.",
      "user.front-login.text.cns": "The CNS is a device with a digital certificate used to access online Public Administration services. To use it, you must install the drivers provided by the issuer.",
      "user.front-login.text.spid": "SPID (Public Digital Identity System) is the authentication system that allows users to access online services of both Public Administration and accredited private organizations through a single digital identity.",
      "user.front-login.text.spid-professionale": "Professional SPID allows businesses and professionals to access Public Administration online services by qualifying as representatives of a legal entity.",
      "user.front-login.title-accesso-dipendenti": "Employee Access",
      "user.front-login.title-spid-professionale": "Professional SPID",
      "user.front-login.title-utenti-italiani": "Italian users",
      "user.login.employee": "Employee Login",
      "user.login.employee-password": "Password",
      "user.login.employee-title": "Employee Access",
      "user.login.employee-username": "Username",
      "user.login.login-button": "Log in",
      "user.login.login-button-employee-access-divider": "EMPLOYEE ACCESS",
      "user.login.login-button-or-divider": "OR",
      "user.login.pa-users.description": "Access restricted to Ministry of Culture personnel.",
      "user.login.pa-users.link.back": "Back",
      "user.login.pa-users.pa-button.utenti-pa": "PA Users",
      "user.login.title": "Log in",
      "widgets.candidate.change-button-text": "Change",
      "widgets.candidate.members-load-error": "Error loading the electoral list members",
      "widgets.candidate.modal-select-member-title": "Select Member",
      "widgets.candidate.select-button-text": "Choose",
      "widgets.electoral-list-chooser.members-load-error": "Error loading the electoral list members",
      "widgets.electoral-list-chooser.no-candidates": "No candidates available",
      "burden-payment-state-tag.attesa-pagamento": "Waiting for Payment",
      "burden-payment-state-tag.da-pagare": "To Pay",
      "burden-payment-state-tag.pagato": "Paid",
      "burden-payment-state-tag.pagato-parzialmente": "Partially Paid",
      "burden-selection-table.seleziona-onere": "Select fee",
      "burden-selection-table.seleziona-oneri": "Select all fees",
      "burden-table.crea-pagamento": "Create Payment",
      "burden-table.totale-selezionato": "Total selected",
      "burdens-columns.da-pagare-dopo-invio": "To be paid after sending",
      "burdens-columns.descrizione": "Description",
      "burdens-columns.facoltativo": "Optional",
      "burdens-columns.importo": "Amount",
      "burdens-columns.obbligatorio": "Required",
      "burdens-columns.stato-onere": "Fee Status",
      "burdens-columns.tipo": "Type",
      "download-receipt.errore-in-download": "A problem occurred while downloading the file",
      "error-submit-module-form.error-saving": "Error while saving",
      "error-submit-module-form.errore-salvataggio-modulo": "Error while saving, Form ID not present",
      "error-submit-module-form.errore-salvataggio-richiesta": "Error while saving, Request ID not present",
      "fillable-form.sezione.sr-only-anchor": "section: {{sectionName}}",
      "form.applicazione-marca-da-bollo": "By applying the stamp duty, the request will be frozen and no changes will be possible.",
      "form.avanti": "Next",
      "form.back-to-inquiries": "Cancel",
      "form.button.paga-il-bollo": "Stamp duty payment",
      "form.conferma": "Confirm",
      "form.conferma-di-procedere": "Do you confirm you want to proceed?",
      "form.elenco-pagamenti": "Payments List",
      "form.errore-in-download": "A problem occurred while downloading the file",
      "form.non-ci-sono-modifiche": "There are no changes to save",
      "form.oneri-della-domanda": "Request Fees",
      "form.procedi-al-pagamento": "Proceed to payment",
      "form.procedi-al-pagamento-bollo": "Proceed to stamp duty payment",
      "form.procedi-al-pagamento-link-esterno": "Proceed to payment (opens external link)",
      "form.salva": "Save",
      "form.salva-modulo-download-pdf": "Save the form to download the PDF document",
      "form.scarica-avviso": "Download Notice",
      "form.scarica-ricevuta": "Download Receipt",
      "form.seleziona-gli-oneri": "Select fees to proceed with payment",
      "menu-items.pagamenti": "Payments",
      "menu-items.riepilogo-e-invio": "Summary and Submission",
      "module-form.avviso-rimozione-moduli": "Please note that once removed the data filled in on the forms will be lost. If reactivated later you will need to refill the forms.",
      "module-form.confermare-le-modifiche-ai-moduli": "Confirm form changes?",
      "module-form.moduli-da-compilare-in-aggiunta": "{{length}} new forms to fill out will be added:",
      "module-form.rimozione-del-modulo-corrente": "The following form will be removed:",
      "module-form.rimozione-moduli": "{{length}} forms will be removed:",
      "module-form.salvando-le-richieste-verranno-apportate-le-modifiche": "Saving the request will make the following changes:",
      "module-form.un-modulo-da-compilare-in-aggiunta": "The following form to fill out will be added:",
      "module-title.altro-modulo": "Other Form",
      "module-tooltip-text.completato": "Completed",
      "module-tooltip-text.in-attesa-della-firma": "Awaiting signature",
      "module-tooltip-text.in-fase-di-compilazione": "In compilation",
      "module-tooltip-text.modulo-non-valido": "Invalid form",
      "module-validation-state-text.compila": "Fill out",
      "module-validation-state-text.completato": "Completed",
      "module-validation-state-text.firma": "Sign",
      "module.state-progress-bar.stato-del-modulo": "Module State",
      "payment-burden-type-tag.bollo": "Stamp duty",
      "payment-burden-type-tag.modello-1": "Spontaneous online payment (Burdens)",
      "payment-burden-type-tag.modello-3": "Deferred payment notice (Burdens)",
      "payment-burden-type-tag.oneri": "Burdens",
      "payment-columns.codice": "Code",
      "payment-columns.importo": "Amount",
      "payment-columns.stato-pagamento": "Payment Status",
      "payment-state-tag.completato": "COMPLETED",
      "payment-state-tag.da-pagare": "TO PAY",
      "payment-state-tag.errore-pagamento": "PAYMENT ERROR",
      "payment-state-tag.pendente": "PENDING",
      "payment-table.azioni": "Actions",
      "payment-table.tipi": "Type",
      "quote-columns.data": "Date",
      "quote-columns.descrizione": "Description",
      "quote-columns.imponibile": "Taxable Amount",
      "quote-columns.importo": "Amount",
      "quote-columns.iva": "VAT",
      "quote-columns.numero": "Number",
      "quote-columns.stato": "Status",
      "quote-state-tag.attesa-approvazione": "Awaiting Approval",
      "quote-state-tag.attesa-pagamento": "Payment Pending",
      "quote-state-tag.pagato": "Paid",
      "quote-state-tag.rifiutato": "Rejected",
      "quote-table.azioni": "Actions",
      "quote-table.azioni.button-confirm.accept.message.accetta-preventivo-prima-riga": "Confirm that you have downloaded and read the quote in its entirety.",
      "quote-table.azioni.button-confirm.accept.message.accetta-preventivo-seconda-riga": "Do you confirm you want to accept the quote?",
      "quote-table.azioni.button-confirm.accept.text": "ACCEPT",
      "quote-table.azioni.button-confirm.refuse.message.rifiuto-preventivo": "Are you sure you want to reject the quote?",
      "quote-table.azioni.button-confirm.refuse.text": "REFUSE",
      "quote-table.azioni.button.aria-label.scarica-preventivo": "Download Quote",
      "quote-table.azioni.button.tooltips.scarica-preventivo": "Download Quote",
      "quote-table.errore-in-accettazione-preventivo": "A problem occurred while accepting the quote",
      "quote-table.errore-in-download-file": "A problem occurred while downloading the file",
      "stamp-duty-payment.avvio-pagamento": "Starting payment...",
      "stamp-duty-payment.errore-avvio-pagamento": "An error occurred while starting the payment",
      "stamp-duty-payment.errore-modifica-stato-pagamento": "An error occurred while modifying the payment status",
      "start-payment-button.avvio-pagamento": "Starting payment...",
      "start-payment-button.errore-avvio-pagamento": "An error occurred while starting the payment",
      "submission-confirm-update.conferma-aggiornamento-modulo": "Do you confirm you want to update the form?",
      "submission-confirm-update.conferma-modifiche": "Confirm form activation changes",
      "submission-consolidated-pdf-button.errore-in-download": "An error occurred while downloading the file",
      "submission-consolidated-pdf-button.scarica-pdf-richiesta": "Download request PDF",
      "submission-consolidated-pdf-button.visualizza-pdf-richiesta": "View request PDF",
      "submission-list.unknown-applicant": "Unidentified",
      "submission-menu-item.bolli": "Stamp Duties",
      "submission-menu-item.oneri": "Fees",
      "submission-menu-item.pagamenti": "Payments",
      "submission-menu-item.preventivi": "Quotes",
      "submission-menu-item.scheda-domanda": "Application Form",
      "submission-menu-item.sezione-disabilitata": "Section disabled",
      "submission-menu-items.altro-modulo": "Other Form",
      "submission-menu-items.modulo-principale": "Main Form",
      "submission-menu-items.sezione": "Section {{index}}",
      "submission-menu-label.aria-label.name-prefix": "Section",
      "submission-menu.navigazione-richiesta": "request navigation",
      "submission-menu.section.dirty-badge.dirty.sezione-da-salvare": "Section to save",
      "submission-menu.section.dirty-badge.error.sezione-non-valida": "Invalid section",
      "submission-menu.selezionato": "selected",
      "submission-module-button.errore-in-download": "A problem occurred while downloading the file",
      "submission-module-button.richiesta-non-pubblica": "***Impossibile scaricare il PDF con Omissis: la Richiesta non è pubblica",
      "submission-module-button.scarica-pdf": "Download PDF",
      "submission-module-button.scarica-pdf-firmato": "Download PDF",
      "submission-module-button.scarica-pdf-omissis": "Download PDF Omissis",
      "submission-module-button.visualizza-pdf": "View PDF",
      "submission-module-button.visualizza-pdf-omissis": "View PDF Omissis",
      "submission-payment-form.errore-richiesta": "An error occurred while loading the request. The request is not defined.",
      "submission-payment-form.errore-richiesta-titolo": "Request not defined",
      "submission-payment-form.oneri-bolli-da-pagare-dopo-invio": "Below you will find the payments to be made following submission",
      "submission-payment-form.pagamento-annullato": "Payment cancelled",
      "submission-payment-form.pagamento-completato": "The payment has been completed successfully",
      "submission-payment-form.pagamento-completato-con-successo": "Payment completed successfully",
      "submission-payment-form.pagamento-errore": "***Si è verificato un errore durante il pagamento",
      "submission-payment-form.seleziona-bolli": "Select stamp duties to proceed with payment",
      "submission-payment-form.seleziona-oneri": "Select fees to proceed with payment",
      "submission-state-tag.bozza": "DRAFT",
      "submission-state-tag.cancellata": "CANCELLED",
      "submission-state-tag.conclusa": "CONCLUDED",
      "submission-state-tag.creata": "CREATED",
      "submission-state-tag.in-invio": "SUBMITTING",
      "submission-state-tag.integrata": "INTEGRATED",
      "submission-state-tag.integrata-dopo-richiesta-integrazione": "Integrated after integration request",
      "submission-state-tag.inviata": "SUBMITTED",
      "submission-state-tag.pagamento": "IN PAYMENT",
      "submission-state-tag.ricevuta": "RECEIVED",
      "submission-state-tag.richiesta-accettazione-preventivo": "Quote acceptance is required",
      "submission-state-tag.richiesta-integrazione": "The request has been enabled for submitting changes and/or integrations",
      "submission-state-tag.richiesta-pagamento-preventivo": "Quote payment is required",
      "submission-state-tag.sono-presenti-preventivi": "Quotes are present",
      "submission.richiesta": "Request",
      "alert-message.error.close-icon-label": "Close",
      "form.alert-message.content": "There are compilation errors ({{errors_count}})",
      "form.error-list.hide": "Hide {{errorCount}} errors",
      "form.error-list.hide_one": "Hide 1 error",
      "form.error-list.show-more": "Show more {{errorCount}} errors",
      "form.error-list.show-more_one": "Show 1 more error",
      "form.prevent-navigation.prompt": "Are you sure you want to leave the page? All unsaved changes will be lost",
      "form.submit-button.save": "Save",
      "form.submit-button.tooltip-not-dirty": "There are no changes to save",
      "inputs.async-select-input-meta.content": "Showing {{shown}} of {{total}}.",
      "inputs.async-select-input-meta.filter": "Filter search by typing to improve results.",
      "inputs.async-select.caricamento-opzioni": "Loading...",
      "inputs.async-select.errore-caricamento-opzioni": "Error loading data",
      "inputs.async-select.nessun-risultato": "No results found",
      "inputs.color.select": "Select Color",
      "inputs.date-input.clear-button": "Clear field",
      "inputs.date-input.error": "The entered date is not valid",
      "inputs.dragger-input-body.title": "Click or drag file to this area to upload",
      "inputs.dragger-input.info": "Allowed formats: {{formats}}",
      "inputs.dragger-input.title": "Click or drag file to this area to upload",
      "inputs.file-extension-select-input.placeholder": "Type and press enter to add a new format",
      "inputs.info-icon-row": "Click on the {{content}} preview icon",
      "inputs.rich-text-link-button.label": "URL",
      "inputs.rich-text-link-button.placeholder": "Enter link URL",
      "inputs.rich-text-menu-bar.align-center": "Align to center",
      "inputs.rich-text-menu-bar.align-left": "Align left",
      "inputs.rich-text-menu-bar.align-right": "Align right",
      "inputs.rich-text-menu-bar.bold": "Bold",
      "inputs.rich-text-menu-bar.color": "Color",
      "inputs.rich-text-menu-bar.hard-break": "Line break",
      "inputs.rich-text-menu-bar.italic": "Italic",
      "inputs.rich-text-menu-bar.justify-text": "Justify text",
      "inputs.rich-text-menu-bar.ordered-list": "Ordered list",
      "inputs.rich-text-menu-bar.strikethrough": "Line break",
      "inputs.rich-text-menu-bar.title": "Title",
      "inputs.rich-text-menu-bar.underline": "Underline",
      "inputs.rich-text-menu-bar.unordered-list": "List",
      "inputs.select.multipla": "(Multiple selection)",
      "inputs.select.nessuna-opzione-disponibile": "(No available options)",
      "inputs.upload-input.title": "Upload file",
      "utils.decorate-with-form.submit": "Submit",
      "async-value-widget.error-message": "An error occurred, please try again later",
      "divider-widget.new-divider-title": "New title divider",
      "info-widget.collapse": "Collapse",
      "info-widget.expand": "Expand",
      "info-widget.new-info-message": "New information message",
      "inputs.rich-text-advanced-link-node.screen-reader-content": "(Opens in a new window)",
      "paragraph-widget.new-paragraph": "New paragraph",
      "payment-row-widget.base-unit-amount": "Unit Price",
      "payment-row-widget.description": "Description",
      "payment-row-widget.discount": "Discount/Exemption",
      "payment-row-widget.quantity": "Quantity",
      "payment-row-widget.taxable-amount": "Taxable Amount",
      "payment-row-widget.title": "Include in payment",
      "payment-row-widget.total": "Total",
      "payment-row-widget.unit": "Unit of Measurement",
      "payment-row-widget.unit-amount": "Unit Price",
      "payment-row-widget.vat": "VAT",
      "payment-row-widget.vat-amount": "VAT",
      "rules.confirm-widget-required.error": "You must confirm or modify the displayed data.",
      "rules.date-range.max-date": "The date must be before {{to_date}}",
      "rules.date-range.min-date": "The date must be after {{from_date}}",
      "rules.item-range.min": "The field ${label} must contain at least {{min}} elements",
      "rules.text-format.number": "The field ${label} is not a number.",
      "rules.text-format.phone": "The field ${label} is not a phone number.",
      "rules.unique-field-rule.error": "The field {{label}} must be unique",
      "rules.value-range.max": "The field ${label} must be less than or equal to {{max}}",
      "rules.value-range.min": "The field ${label} must be greater than or equal to {{min}}",
      "subsection.drawer.button.back": "Back",
      "ui.info-icon.content": "Additional information text",
      "widget.async-table-widget-error-description": "***Impossibile visualizzare la tabella. Si è verificato un errore durante il caricamento dei dati. Riprovare",
      "widget.async-table-widget-error-title": "***Errore durante il caricamento della tabella \"{{widgetCode}}\"",
      "widgets.add-row-buttton.add": "Add",
      "widgets.add-row-buttton.max-options-reached": "Maximum number of options reached",
      "widgets.async-select-widget-component.not-found": "No items found.",
      "widgets.async-select-widget-component.service-not-responding": "Unable to retrieve data from {{service}} service. Please try again later.",
      "widgets.async-select-widget-component.type-to-search": "Type to start searching",
      "widgets.async-select.select-text": "Choose",
      "widgets.confirm-widget-layout-component.cancel": "Cancel Changes",
      "widgets.confirm-widget-layout-component.confirm": "Confirmed",
      "widgets.confirm-widget-layout-component.edit": "Edit",
      "widgets.multi-select-select-component.placeholder": "Placeholder",
      "widgets.remove-row-buttton.min-options-reached": "Minimum number of options reached",
      "widgets.repeatable-content.alert-sr.added": "***Elemento {{index}} aggiunto alla lista {{labelText}}.",
      "widgets.repeatable-content.alert-sr.removed": "***Elemento {{index}} rimosso dalla lista {{labelText}}. Gli elementi successivi sono stati riordinati.",
      "widgets.select-widget.select-text": "Choose",
      "widgets.subsection-drawer-component.expand-aria": "Expand",
      "widgets.subsection-drawer-component.open": "Open",
      "widgets.use-exec-async-service-action.error-during-loading": "An error occurred while executing the asynchronous service",
      "widgets.use-exec-async-service-action.no-handle-function": "An error occurred while executing the asynchronous service, retry.",
      "widgets.use-repeat-controller-confirm-modal.cancel": "Cancel",
      "widgets.use-repeat-controller-confirm-modal.content": "By reducing the number of elements, you will remove excess rows from the list. Continue?",
      "widgets.use-repeat-controller-confirm-modal.continue": "Continue",
      "widgets.use-repeat-controller-confirm-modal.title": "Remove items from list?",
      "ai-file-check-message.tooltip.suggestions": "Proceed or upload the document again.",
      "ai-file-check-message.warning.not-identification": "The document type does not match the requested type",
      "ai-module-check-message.success.digitally-signed": "Digitally signed form.",
      "ai-module-check-message.warning.not-signatures": "The form does not appear to be correctly signed.",
      "ai-module-check-message.warning.not-similatity": "The uploaded form document appears to be different from the downloaded one.",
      "ai-module-check-message.warning.suggestions": "To upload the form document again, return to form editing mode.",
      "button-icon-toggle-read.mark-as-read": "Mark as read",
      "button-icon-toggle-read.read": "Read",
      "button-icon-toggle-read.read-on": "Read on",
      "button-icon-toggle-read.unread": "unread",
      "cmmunication-state-tag.default": "N/A",
      "cmmunication-state-tag.error": "Sending Failed",
      "cmmunication-state-tag.processing": "In Processing",
      "cmmunication-state-tag.success": "Sent",
      "common.communication-search-form.extended-search": "Extended Search",
      "common.communication-search-form.remove-filters": "Remove Filters",
      "common.communication-search-form.search": "Search",
      "common.communication-search-form.search-button": "Search",
      "common.communication-search-form.search-placeholder": "Search...",
      "common.communication-search-form.subject": "Subject",
      "communication-attachment-group-editor.must-save-communication": "It is necessary to save the communication",
      "communication-attachment-group-editor.upload-file": "Upload file {{maxCount}}",
      "communication-attachments.attachments": "Attachments",
      "communication-attachments.title": "Attachments",
      "communication-button.new-comm": "New Communication",
      "communication-button.send-comm": "Send Communication",
      "communication-details.receiver": "Recipients",
      "communication-details.sender": "Sender",
      "communication-extend-search-form.communication-type": "Communication Type",
      "communication-extend-search-form.message": "Message",
      "communication-extend-search-form.search-in-message": "Search in message...",
      "communication-extend-search-form.send-date": "Send Date",
      "communication-extend-search-form.sent-after": "Sent after",
      "communication-extend-search-form.sent-before": "Sent before",
      "communication-extend-search-form.so": "Sorting",
      "communication-extend-search-form.sort-by": "Sort by...",
      "communication-extend-search-form.subject": "Subject",
      "communication-extend-search-form.write-or-select-date": "Write or select date...",
      "communication-header.receivers": "Recipients",
      "communication-header.sender": "Sender",
      "communication-item.edit": "Edit",
      "communication-item.edit-and-send": "Edit and Send",
      "communication-item.reply": "Reply",
      "communication-list.no-comms-to-show": "No communications to show",
      "communication-recipient.protocol-number": "Protocol",
      "communication-recipient.registration-date": "Protocol date",
      "communication-recipient.send-date": "Date sent",
      "communication-request-schema.addictional-notes": "Additional Notes",
      "communication-request-schema.communication-type": "Communication Type",
      "communication-request-schema.manually-loaded": "Manually loaded",
      "communication-request-schema.message": "Message",
      "communication-request-schema.protocol-date": "Protocol Date",
      "communication-request-schema.protocol-number": "Protocol Number",
      "communication-request-schema.receiver-office": "Recipient Office",
      "communication-request-schema.sender-office": "Sender Office",
      "communication-request-schema.subject": "Subject",
      "communication-search-schema.sent-after": "Sent after",
      "communication-search-schema.sent-before": "Sent before",
      "communication-searchable.search-by-type": "Search by type...",
      "communication-tag-option-holder": "HOLDER",
      "communication-tag-option.applicant": "APPLICANT",
      "communication-tag-option.co-holder": "INTERESTED PARTY",
      "communication-tag-option.delegate-for-comp": "DELEGATE FOR COMPILATION",
      "communication-tag-option.delegate-for-sign": "DELEGATE FOR SIGNATURE",
      "communication-tag-option.manager": "MANAGER",
      "communication-tag-option.no-type": "N/A",
      "communication-tag-option.other-variable-office": "OTHER VARIABLE OFFICE",
      "communication-tag-option.prosecutor": "PROSECUTOR",
      "communication-tag-option.responsible-office": "RECEIVING OFFICE",
      "communication-tag-option.third-organization": "THIRD ORGANIZATION",
      "communication-type.message": "Message",
      "communication-type.receivers": "Recipients",
      "communication-type.sender": "Sender",
      "communication.draft": "DRAFT",
      "communication.sent": "SENT",
      "communications-sender-protocol.protocol-date": "***Data protocollo",
      "communications-sender-protocol.protocol-number": "***Protocollo",
      "communications-sender-protocol.tag.errore": "***ERRORE",
      "communications-sender-protocol.tag.processing": "***IN LAVORAZIONE",
      "communications-sender-protocol.tooltip-title.error-protocolling": "***Errore nella protocollazione della comunicazione",
      "communications-sender-protocol.tooltip-title.processing-protocolling": "***Protocollo in lavorazione",
      "communications.additional-notes": "Additional notes",
      "communications.additional-notes-placeholder": "Additional notes to the communication",
      "communications.error-in-communication": "Error in communication",
      "communications.error-in-sending-communication": "Error in sending the communication",
      "communications.error-protocolling-communication": "Error in protocol registration operations",
      "communications.in-working": "Communication in progress",
      "communications.protocol-date": "Protocol Date",
      "communications.protocol-number": "Protocol Number",
      "communications.select": "Selection...",
      "communications.select-receiver-subprocedure": "Select recipient endoprocedure",
      "communications.subject": "Subject",
      "communications.subject-placeholder": "Communication subject",
      "communications.type-label": "Communication Type",
      "communications.type-row": "Communication Type",
      "communications.type-title": "Type of Communication",
      "competence-widget.error-fetching-competences": "Unable to retrieve Competence data. Please try again later.",
      "competence-widget.info-message": "Competence {{competenceName}} has been automatically selected based on the indicated geometries.",
      "competence-widget.no-element-found": "No items found.",
      "comunicazioni.tooltip-salva-prima-di-inviare": "Save the communication before sending it",
      "confirm-update-modal.added-new-module-activation": "A new module activation has been added:",
      "confirm-update-modal.added-new-multiple-modules-activation": "{{length}} new module activations have been added:",
      "confirm-update-modal.changes-will-be-applied-to-inquiries": "Changes will be made to {{inquiriesLength}} request{{oneOrMore}}:",
      "confirm-update-modal.removed-module-activation": "A module activation has been removed:",
      "confirm-update-modal.removed-multiple-modules-activation": "{{length}} module activations have been removed:",
      "domanda.copertina.categorie": "Categories",
      "domanda.copertina.destinatari": "Recipients",
      "domanda.copertina.scadenza": "Expiration",
      "download-file-button.error-download-file": "There was a problem downloading the file",
      "download-file.error-downloading-file": "There was a problem downloading the file",
      "download-file.no-filename-from-header": "Document",
      "download-widget.error": "There was a problem downloading the file. Try again.",
      "download-widget.file-not-found": "File not found",
      "email-verification-rule.message": "You need to verify your email to continue",
      "email-verification-widget.check-mail-box-to-confirm": "A verification email has been sent to your mailbox. Please check your email to confirm your email address.",
      "email-verification-widget.confirm-reception": "Confirm Receipt",
      "email-verification-widget.error-in-sending-verification-mail": "Error sending verification email",
      "email-verification-widget.invalid-email": "Invalid E-mail",
      "email-verification-widget.verified": "Verified",
      "email-verification-widget.verify-email": "Verify Email",
      "error-while-resetting-notification-flag": "Error resetting notification flag",
      "export--multiple-semantic-field-select.select--multiple-semantic-fields-to-export": "***Seleziona i campi semantici multipli da esportare come righe",
      "export--multiple-semantic-field-select.select-multiple-semantic-fields-to-export-title": "***Seleziona i campi semantici multipli da esportare. Verrà aggiunta una riga per ogni campo semantico multiplo.",
      "export-field-select.select-fields-to-export": "Select fields to export",
      "export-field-select.select-fields-to-export-title": "Select fields to export. If you do not indicate any fields the export will contain all the data.",
      "export-file-button.cancel-text": "Cancel",
      "export-file-button.confirm-export": "You are about to export the data found by the currently active search filters{{exportAll}}. Depending on filters used this operation may take some time. Continue?",
      "export-file-button.download-page": "Download only one page (max. {{pageSize}} {{entity}})",
      "export-file-button.export-procedures": "Export {{typeTitle}} Procedures",
      "export-file-button.export-title": "Export {{typeTitle}}",
      "export-file-button.ok-text": "Export",
      "export-file-button.remember-fields": "Remember fields for next export",
      "export-semantic-order.placeholder": "Add sorting",
      "interazioni.annulla": "Cancel",
      "interazioni.salva": "Save",
      "map-widget.drawn-geometries": "Drawn geometries",
      "map-widget.geometries.point-title": "#{{numero}}",
      "map-widget.intersections": "Intersections",
      "map-widget.no-geometries": "No geometries present",
      "map-widget.search-address.aria-label": "Search address",
      "map-widget.search-address.load-address-error-mpe-002": "Error loading address (MPE-002)",
      "map-widget.search-address.no-result-found-no-extent-mpe-0001": "No results found for selected address (MPE-0001)",
      "map-widget.search-address.not-found-text.loading": "Loading...",
      "map-widget.search-address.not-found-text.no-result": "No results",
      "map-widget.search-address.not-found-text.write-to-search": "Write to search",
      "map-widget.search-address.placeholder": "Search address...",
      "map-widget.title": "Center map on geometry data",
      "map-widget.upload-warning-message": "No geometry data present in the file.",
      "mappa.controlli.cerca-particella.modale.form-button.cerca": "Search",
      "mappa.controlli.cerca-particella.modale.form-button.seleziona": "Select",
      "mappa.controlli.cerca-particella.modale.form-label.allegato-catastale": "Cadastral attachment",
      "mappa.controlli.cerca-particella.modale.form-label.comune": "Municipality",
      "mappa.controlli.cerca-particella.modale.form-label.foglio-catastale": "Cadastral Sheet",
      "mappa.controlli.cerca-particella.modale.form-label.particella-catastale": "Cadastral parcel",
      "mappa.controlli.cerca-particella.modale.form-label.sezione-catastale": "Cadastral section",
      "mappa.controlli.cerca-particella.modale.form-label.sviluppo-catastale": "Cadastral Development",
      "mappa.controlli.cerca-particella.modale.form.errore.durante-la-ricerca": "An error occurred while searching",
      "mappa.controlli.cerca-particella.modale.form.errore.nessun-risultato": "No results found",
      "mappa.controlli.cerca-particella.modale.form.errore.nessuna-geometria-valida": "Error while searching. No valid geometry data found",
      "mappa.controlli.cerca-particella.modale.titolo": "Search by cadastral parcel",
      "mappa.controlli.cerca-particella.pulsante.testo": "Parcel",
      "mappa.controlli.disegna": "Draw",
      "mappa.controlli.elimina": "Delete",
      "mappa.controlli.visualizza": "View",
      "mappa.livelli.popover.form-item-label-prefix.visibilita": "Visibility",
      "mappa.livelli.popover.pulsante-chiudi": "Close",
      "mappa.livelli.popover.titolo.visibilita-dei-livelli": "Layer Visibility",
      "mappa.livelli.pulsante": "Layers",
      "notification-drawer.priority-tag.alta": "HIGH",
      "notification-drawer.priority-tag.bassa": "LOW",
      "notification-drawer.priority-tag.normale": "NORMAL",
      "notification-drawer.priority-tag.priorita": "Priority:",
      "notification-drawer.priority-tag.urgente": "URGENT",
      "notification-drawer.title": "Notifications",
      "notification-filter-switch.all": "All",
      "notification-filter-switch.to-read": "Unread",
      "notification-type-icon.warning": "Warning",
      "notification.error": "An error occurred please try again.",
      "notifiche.alt-image-notifica-da-leggere ": "Notification Unread",
      "notifiche.alt-image-notifica-letta": "Notification Read",
      "notifiche.da-leggere ": "Unread",
      "notifiche.letta-il": "Read on",
      "notifiche.segna-come-letta": "Mark as read",
      "province-widget-schema.mun-belfiore.code": "Municipality Belfiore Code",
      "province-widget-schema.mun-cap": "Municipality ZIP Code",
      "province-widget-schema.mun-istat": "Municipality ISTAT Code",
      "province-widget-schema.mun-lat": "Municipality Latitude",
      "province-widget-schema.mun-lng": "Municipality Longitude",
      "province-widget-schema.mun-name": "Municipality Name",
      "province-widget-schema.mun-province": "Municipality Province",
      "province-widget-schema.mun-region": "Municipality Region",
      "province-widget-schema.prov-belfiore-code": "Belfiore Code",
      "province-widget-schema.prov-lat": "Province Latitude",
      "province-widget-schema.prov-lng": "Province Longitude",
      "province-widget-schema.prov-name": "Province Name",
      "province-widget-schema.prov-region": "Province Region",
      "province-widget.error": "Error",
      "province-widget.error-description": "Error loading province data. Please try again later.",
      "recipient-type.dipendente": "Employee",
      "recipient-type.ente-pubblico": "Public Entity",
      "recipient-type.persona-fisica": "Natural Person",
      "recipient-type.persona-giuridica": "Legal Entity",
      "semantic-tag-searchable-field.from": "From",
      "semantic-tag-searchable-field.to": "TO",
      "stato.tipo-domanda.annullata": "CANCELED",
      "stato.tipo-domanda.aperta": "OPEN",
      "stato.tipo-domanda.bozza": "DRAFT",
      "stato.tipo-domanda.chiusa": "CLOSED",
      "stato.tipo-domanda.collaudo": "TESTING",
      "stato.tipo-domanda.in-corso": "IN PROGRESS",
      "stato.tipo-domanda.pronta": "READY",
      "stato.tipo-domanda.pubblicata": "PUBLISHED",
      "stato.tipo-domanda.sola-lettura": "READ ONLY",
      "stato.tipo-domanda.sospesa": "SUSPENDED",
      "triggerable-modules-confirm-update.generic-error": "A generic error occurred please try again later",
      "upload-widget.file-must-be-uploaded": "The file ${label} must be loaded",
      "upload-widget.filelist.download-file": "Download File",
      "upload-widget.public-doc": "Public document",
      "uploaded-file-row.button-delete-confirm.button-aria-label": "Delete file",
      "uploaded-file-row.button-delete-confirm.title": "Are you sure you want to remove the file?",
      "widget-immagine.anteprima": "Image preview",
      "widget-immagine.chiudi": "Close",
      "widget-immagine.scarica": "Download image",
      "user.auto-login.response.error.sub-title": "Unable to complete the login procedure.",
      "user.auto-login.response.error.title": "Login Error",
      "user.auto-login.response.success.submit-button": "Back to Login",
      "user.login.cie-button": "Login with CIE",
      "user.login.cns-button": "Login with CNS",
      "user.login.cns-error": "An error occurred during access via CNS. A valid certificate for authentication could not be retrieved. Please check the CNS access requirements and try again. (CNS002)",
      "user.login.cns-technical-error": "A technical error occurred during login (CNS001).",
      "user.login.eidas-button": "Login with eIDAS",
      "user.login.spid-button": "Login with SPID",
      "user.login.spid-link.dont-have-spid": "Don't Have SPID?",
      "user.login.spid-link.dont-have-spid-url": "https://www.spid.gov.it/richiedi-spid",
      "user.login.spid-link.info": "More Information",
      "user.login.spid-link.info-url": "https://www.spid.gov.it",
      "user.login.spid-link.need-help": "Need Help?",
      "user.login.spid-link.need-help-url": "https://www.spid.gov.it/serve-aiuto",
      "user.login.spid-popover.text-part-a": "SPID is the access system that allows you to use online services of the Public Administration, both central and local, and of accredited private entities, with a single digital identity.",
      "user.login.spid-popover.text-part-b": "If you are italian citizen and already have a digital identity, log in with your provider's credentials. If you do not yet have a digital identity, request it using the following link:",
      "user.login.spid-popover.title": "Access with SPID Account",
      "user.login.spid-professional-button": "Access with Professional SPID",
      "user.login.external-user-email": "E-mail",
      "user.login.external-user-password": "Password",
      "user.login.password-forgot-link": "Reset Password",
      "user.login.password-forgot-question": "Forgot Password?",
      "user.login.sign-in-link": "Go to Registration Form",
      "user.login.sign-in-question": "Not Registered on the Portal Yet?"
    }
  }
} as const;

export const i18nNamespaces = ["translation"] as const
